import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  apps: Array<App>;
  createdAt: Scalars['Date']['output'];
  deletionRequestingUser?: Maybe<User>;
  ensembleAccountManagerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryContactEmail: Scalars['String']['output'];
  primaryContactName: Scalars['String']['output'];
  primaryContactPhone: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AccountScreen = {
  __typename?: 'AccountScreen';
  backgroundImage?: Maybe<Image>;
};

export type AllStatus = {
  __typename?: 'AllStatus';
  account: Scalars['String']['output'];
  app: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSuccessfulDate?: Maybe<Scalars['Date']['output']>;
  status: Status;
};

export type App = {
  __typename?: 'App';
  account: Account;
  config: FlowConfig;
  configs: Array<FlowConfig>;
  createdAt: Scalars['Date']['output'];
  deletionRequestingUser?: Maybe<User>;
  feeds: PaginatedFeedSet;
  id: Scalars['ID']['output'];
  lastPublished: Scalars['Date']['output'];
  locales: Array<Locale>;
  name: Scalars['String']['output'];
  platforms: Array<AppPlatform>;
  screens: Array<Screen>;
  status: GenerationStatus;
  theme: Theme;
  website?: Maybe<Scalars['String']['output']>;
};


export type AppConfigArgs = {
  environment: Environment;
  platformId: Scalars['ID']['input'];
};


export type AppConfigsArgs = {
  environment: Environment;
};


export type AppFeedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Environment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type AppScreensArgs = {
  environment?: InputMaybe<Environment>;
};


export type AppStatusArgs = {
  environment: Environment;
};


export type AppThemeArgs = {
  environment?: InputMaybe<Environment>;
};

export type AppExitScreen = {
  __typename?: 'AppExitScreen';
  backgroundImage?: Maybe<Image>;
};

export type AppPlatform = {
  __typename?: 'AppPlatform';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppSettingsScreen = {
  __typename?: 'AppSettingsScreen';
  backgroundImage?: Maybe<Image>;
};

export type AreYouStillWatchingScreen = {
  __typename?: 'AreYouStillWatchingScreen';
  countdown: Scalars['Int']['output'];
  inactivityInterval: Scalars['Int']['output'];
};

export type AudioPlaybackScreen = {
  __typename?: 'AudioPlaybackScreen';
  backgroundImage: Image;
  imageLayout: ImageLayout;
  progressHeartbeat: Scalars['Int']['output'];
  upNextCountdown: Scalars['Int']['output'];
  upNextCue?: Maybe<Scalars['Int']['output']>;
};

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  newDeviceMetadata?: Maybe<NewDeviceMetadata>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type BrowseBScreen = {
  __typename?: 'BrowseBScreen';
  backgroundImage?: Maybe<Image>;
};

export type BrowseCScreen = {
  __typename?: 'BrowseCScreen';
  backgroundImage?: Maybe<Image>;
};

export type BrowseDScreen = {
  __typename?: 'BrowseDScreen';
  backgroundImage?: Maybe<Image>;
};

export type BrowseScreen = {
  __typename?: 'BrowseScreen';
  backgroundImage?: Maybe<Image>;
};

export type CcpaPrivacyScreen = {
  __typename?: 'CCPAPrivacyScreen';
  backgroundImage?: Maybe<Image>;
};

export enum CertificationStatus {
  Blocked = 'BLOCKED',
  InReview = 'IN_REVIEW',
  None = 'NONE',
  Passed = 'PASSED'
}

export type CompleteStatus = {
  __typename?: 'CompleteStatus';
  account: Scalars['String']['output'];
  app: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSuccessfulDate?: Maybe<Scalars['Date']['output']>;
  logs: Array<FormatedLog>;
  status: Status;
};

export type ConfigIntegration = {
  __typename?: 'ConfigIntegration';
  createdAt: Scalars['Date']['output'];
  integration: Integration;
  settingsJson: Scalars['JSON']['output'];
};

export type ContinueWatchingScreen = {
  __typename?: 'ContinueWatchingScreen';
  backgroundImage?: Maybe<Image>;
};

export type CreateAccountInput = {
  ensembleAccountManagerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
  primaryContactPhone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateAccountScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppExitScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppInput = {
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppSettingsScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAreYouStillWatchingScreenInput = {
  countdown: Scalars['Int']['input'];
  inactivityInterval: Scalars['Int']['input'];
};

export type CreateAudioPlaybackScreenInput = {
  backgroundImage: Scalars['String']['input'];
  imageLayout: ImageLayout;
  progressHeartbeat: Scalars['Int']['input'];
  upNextCountdown: Scalars['Int']['input'];
  upNextCue: Scalars['Int']['input'];
};

export type CreateBrowseBScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBrowseCScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBrowseDScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBrowseScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCcpaPrivacyScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContinueWatchingScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeleteAccountConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeleteAccountScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateErrorScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFaqScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFavoritesScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFeedInput = {
  contentDetailIntegrationKey: Scalars['String']['input'];
  contentIntegrationKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nested: Scalars['Boolean']['input'];
  type: FeedType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFlowConfigInput = {
  features: Array<Feature>;
  minSDKVersion: Scalars['String']['input'];
};

export type CreateForceUpdateScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateForgotPasswordConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateForgotPasswordExternalScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateForgotPasswordScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHomeMiniPlayerScreenInput = {
  autoFullScreenTransition: Scalars['Int']['input'];
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHomeScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  backgroundImageLayout: ImageLayout;
};

export type CreateLoginCodeScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  pollingIntervalSeconds: Scalars['Int']['input'];
  qrCode: Scalars['Boolean']['input'];
};

export type CreateLoginScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLogoutConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManageSubscriptionScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMovieDetailScreenInput = {
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNavBarItemInput = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  iconKey: Scalars['String']['input'];
  label: Scalars['String']['input'];
  requireAuthenticated: Scalars['Boolean']['input'];
  requireSubscribed: Scalars['Boolean']['input'];
  screenType: ScreenType;
};

export type CreateParentalPinForgotScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParentalPinForgotSetScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParentalPinScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParentalPinSetScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaywallScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlaylistDetailScreenInput = {
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePrivacyConsentScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePrivacyPolicyScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRecommendationsChannelScreenInput = {
  icon: Scalars['String']['input'];
};

export type CreateRegisterScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  passwordLowercase: Scalars['Boolean']['input'];
  passwordMinCharacters: Scalars['Int']['input'];
  passwordNonAlphanumeric: Scalars['Boolean']['input'];
  passwordNumber: Scalars['Boolean']['input'];
  passwordUppercase: Scalars['Boolean']['input'];
};

export type CreateScreenFeedInput = {
  action: ScreenAction;
  environment: Environment;
  feedId: Scalars['ID']['input'];
  itemLayout: ScreenItemLayout;
  layout: ScreenLayout;
  screenId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScreenInput = {
  account?: InputMaybe<CreateAccountScreenInput>;
  allowAppRefresh: Scalars['Boolean']['input'];
  appExit?: InputMaybe<CreateAppExitScreenInput>;
  appSettings?: InputMaybe<CreateAppSettingsScreenInput>;
  areYouStillWatching?: InputMaybe<CreateAreYouStillWatchingScreenInput>;
  audioPlayback?: InputMaybe<CreateAudioPlaybackScreenInput>;
  browse?: InputMaybe<CreateBrowseScreenInput>;
  browseB?: InputMaybe<CreateBrowseBScreenInput>;
  browseC?: InputMaybe<CreateBrowseCScreenInput>;
  browseD?: InputMaybe<CreateBrowseDScreenInput>;
  ccpaPrivacy?: InputMaybe<CreateCcpaPrivacyScreenInput>;
  continueWatching?: InputMaybe<UpdateContinueWatchingScreenInput>;
  deleteAccount?: InputMaybe<CreateDeleteAccountScreenInput>;
  deleteAccountConfirmation?: InputMaybe<CreateDeleteAccountConfirmationScreenInput>;
  error?: InputMaybe<CreateErrorScreenInput>;
  faq?: InputMaybe<CreateFaqScreenInput>;
  favorites?: InputMaybe<CreateFavoritesScreenInput>;
  forceUpdate?: InputMaybe<CreateForceUpdateScreenInput>;
  forgotPassword?: InputMaybe<CreateForgotPasswordScreenInput>;
  forgotPasswordConfirmation?: InputMaybe<CreateForgotPasswordConfirmationScreenInput>;
  forgotPasswordExternal?: InputMaybe<CreateForgotPasswordExternalScreenInput>;
  home?: InputMaybe<CreateHomeScreenInput>;
  homeMiniPlayer?: InputMaybe<CreateHomeMiniPlayerScreenInput>;
  login?: InputMaybe<CreateLoginScreenInput>;
  loginCode?: InputMaybe<CreateLoginCodeScreenInput>;
  logoutConfirmation?: InputMaybe<CreateLogoutConfirmationScreenInput>;
  manageSubscription?: InputMaybe<CreateManageSubscriptionScreenInput>;
  movieDetail?: InputMaybe<CreateMovieDetailScreenInput>;
  name: Scalars['String']['input'];
  parentalPin?: InputMaybe<CreateParentalPinScreenInput>;
  parentalPinForgot?: InputMaybe<CreateParentalPinForgotScreenInput>;
  parentalPinForgotSet?: InputMaybe<CreateParentalPinForgotSetScreenInput>;
  parentalPinSet?: InputMaybe<CreateParentalPinSetScreenInput>;
  paywall?: InputMaybe<CreatePaywallScreenInput>;
  platforms: Array<Scalars['String']['input']>;
  playlistDetail?: InputMaybe<CreatePlaylistDetailScreenInput>;
  privacyConsent?: InputMaybe<CreatePrivacyConsentScreenInput>;
  privacyPolicy?: InputMaybe<CreatePrivacyPolicyScreenInput>;
  recommendationsChannel?: InputMaybe<CreateRecommendationsChannelScreenInput>;
  register?: InputMaybe<CreateRegisterScreenInput>;
  screenFeeds: Array<Screen_ScreenFeedInput>;
  search?: InputMaybe<CreateSearchScreenInput>;
  seriesDetail?: InputMaybe<CreateSeriesDetailScreenInput>;
  splash?: InputMaybe<CreateSplashScreenInput>;
  support?: InputMaybe<CreateSupportScreenInput>;
  termsPurchase?: InputMaybe<CreateTermsPurchaseScreenInput>;
  termsService?: InputMaybe<CreateTermsServiceScreenInput>;
  thirdPartySoftware?: InputMaybe<CreateThirdPartySoftwareScreenInput>;
  translations: Array<UpdateLocalizedTranslationInput>;
  type: ScreenType;
  upsell?: InputMaybe<CreateUpsellScreenInput>;
  videoPlayback?: InputMaybe<CreateVideoPlaybackScreenInput>;
  welcome?: InputMaybe<CreateWelcomeScreenInput>;
  welcomePrivacyConsent?: InputMaybe<CreateWelcomePrivacyConsentScreenInput>;
};

export type CreateSearchScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSeriesDetailScreenInput = {
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSplashScreenInput = {
  backgroundImage: Scalars['String']['input'];
};

export type CreateSubscriptionProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isInUse: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type CreateSupportScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTermsPurchaseScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTermsServiceScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThemeColorsInput = {
  background: Scalars['String']['input'];
  badge: Scalars['String']['input'];
  button: Scalars['String']['input'];
  buttonBorder: Scalars['String']['input'];
  buttonFocused: Scalars['String']['input'];
  buttonFocusedBorder: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  buttonTextFocused: Scalars['String']['input'];
  cardFocusedBorder: Scalars['String']['input'];
  cardPlaceholder: Scalars['String']['input'];
  loadingIndicator: Scalars['String']['input'];
  navBarBackground: Scalars['String']['input'];
  overlay: Scalars['String']['input'];
  progress: Scalars['String']['input'];
  separator: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  text: Scalars['String']['input'];
  textInput: Scalars['String']['input'];
  textInputBorder: Scalars['String']['input'];
  textInputFocused: Scalars['String']['input'];
  textInputFocusedBorder: Scalars['String']['input'];
  textSecondary: Scalars['String']['input'];
  underline: Scalars['String']['input'];
};

export type CreateThemeInput = {
  colors: CreateThemeColorsInput;
  landscapeFallbackKey?: InputMaybe<Scalars['String']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  portraitFallbackKey?: InputMaybe<Scalars['String']['input']>;
  premiumIconKey?: InputMaybe<Scalars['String']['input']>;
  squareFallbackKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThirdPartySoftwareScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUpsellScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  appIds: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CreateVideoPlaybackScreenInput = {
  imageLayout: ImageLayout;
  prerollAdFrequency: Scalars['Int']['input'];
  progressHeartbeat: Scalars['Int']['input'];
  upNextCountdown: Scalars['Int']['input'];
  upNextCue: Scalars['Int']['input'];
};

export type CreateWelcomePrivacyConsentScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWelcomeScreenInput = {
  alwaysShowOnLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatedFeed = {
  __typename?: 'CreatedFeed';
  id: Scalars['ID']['output'];
};

export type CreatedScreen = {
  __typename?: 'CreatedScreen';
  id: Scalars['ID']['output'];
};

export type DeleteAccountConfirmationScreen = {
  __typename?: 'DeleteAccountConfirmationScreen';
  backgroundImage?: Maybe<Image>;
};

export type DeleteAccountScreen = {
  __typename?: 'DeleteAccountScreen';
  backgroundImage?: Maybe<Image>;
};

export enum DeletionResult {
  NeedSecondDeletion = 'NEED_SECOND_DELETION',
  Success = 'SUCCESS'
}

export enum DeliveryMedium {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum Environment {
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
  Staging = 'STAGING'
}

export type ErrorScreen = {
  __typename?: 'ErrorScreen';
  backgroundImage?: Maybe<Image>;
};

export type FaqScreen = {
  __typename?: 'FAQScreen';
  backgroundImage?: Maybe<Image>;
};

export type FavoritesScreen = {
  __typename?: 'FavoritesScreen';
  backgroundImage?: Maybe<Image>;
};

export enum Feature {
  Avod = 'AVOD',
  GatedLogin = 'GATED_LOGIN',
  GatedSubscription = 'GATED_SUBSCRIPTION',
  Svod = 'SVOD'
}

export type Feed = {
  __typename?: 'Feed';
  app: App;
  contentDetailIntegration: Integration;
  contentIntegration: Integration;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  environment: Environment;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nested: Scalars['Boolean']['output'];
  platforms: Array<Platform>;
  screenFeeds: Array<ScreenFeed>;
  type: FeedType;
  url?: Maybe<Scalars['String']['output']>;
};


export type FeedPlatformsArgs = {
  environment?: InputMaybe<Environment>;
};


export type FeedScreenFeedsArgs = {
  environment?: InputMaybe<Environment>;
};

export type FeedEdge = {
  __typename?: 'FeedEdge';
  cursor: Scalars['String']['output'];
  node: Feed;
};

export enum FeedType {
  Categories = 'CATEGORIES',
  Content = 'CONTENT',
  ContinueWatching = 'CONTINUE_WATCHING',
  Favorites = 'FAVORITES',
  RecentlyWatched = 'RECENTLY_WATCHED',
  Showcase = 'SHOWCASE'
}

export type File = {
  __typename?: 'File';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type FlowConfig = {
  __typename?: 'FlowConfig';
  certificationStatus: CertificationStatus;
  deletionRequestingUser?: Maybe<User>;
  environment: Environment;
  features: Array<Feature>;
  flowVersion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrations: Array<ConfigIntegration>;
  lastModified: Scalars['Date']['output'];
  lastModifiedByUser?: Maybe<User>;
  minSDKVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  navBarItems: Array<NavBarItem>;
  platform: Platform;
  screens: Array<Screen>;
  subscriptionProducts: Array<SubscriptionProduct>;
};


export type FlowConfigIntegrationsArgs = {
  type?: InputMaybe<IntegrationType>;
};

export type FlowConfigAddUpdateIntegrationInput = {
  integrationId: Scalars['String']['input'];
  settingsJson: Scalars['JSON']['input'];
};

export type FlowConfigIntegrationInput = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  settingsJson: Scalars['JSON']['input'];
  type: IntegrationType;
};

export type ForceUpdateScreen = {
  __typename?: 'ForceUpdateScreen';
  backgroundImage?: Maybe<Image>;
};

export type ForgotPasswordConfirmationScreen = {
  __typename?: 'ForgotPasswordConfirmationScreen';
  backgroundImage?: Maybe<Image>;
};

export type ForgotPasswordExternalScreen = {
  __typename?: 'ForgotPasswordExternalScreen';
  backgroundImage?: Maybe<Image>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  deliveryMedium?: Maybe<DeliveryMedium>;
  destination?: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordScreen = {
  __typename?: 'ForgotPasswordScreen';
  backgroundImage?: Maybe<Image>;
};

export type FormatedLog = {
  __typename?: 'FormatedLog';
  message: Scalars['String']['output'];
};

export type GenerationStatus = {
  __typename?: 'GenerationStatus';
  logs: Array<FormatedLog>;
  state?: Maybe<Status>;
};

export type HomeMiniPlayerScreen = {
  __typename?: 'HomeMiniPlayerScreen';
  autoFullScreenTransition: Scalars['Int']['output'];
  backgroundImage?: Maybe<Image>;
};

export type HomeScreen = {
  __typename?: 'HomeScreen';
  backgroundImage?: Maybe<Image>;
  backgroundImageLayout: ImageLayout;
};

export type Image = {
  __typename?: 'Image';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum ImageLayout {
  Landscape = 'Landscape',
  Square = 'Square'
}

export enum ImageType {
  Background = 'BACKGROUND',
  Standard = 'STANDARD'
}

export type Integration = {
  __typename?: 'Integration';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  type: IntegrationType;
};

export enum IntegrationType {
  Account = 'ACCOUNT',
  Analytics = 'ANALYTICS',
  Content = 'CONTENT',
  DeepLinks = 'DEEP_LINKS',
  Favorite = 'FAVORITE',
  History = 'HISTORY',
  Image = 'IMAGE',
  Logs = 'LOGS',
  Playback = 'PLAYBACK',
  Player = 'PLAYER',
  Subscription = 'SUBSCRIPTION'
}

export type Locale = {
  __typename?: 'Locale';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LocalizationNamespace {
  Badge = 'BADGE',
  Tag = 'TAG',
  TuneIn = 'TUNE_IN'
}

export type LocalizedTranslation = {
  __typename?: 'LocalizedTranslation';
  isFallbackToDefault: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  localeCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LoggedInUser = {
  __typename?: 'LoggedInUser';
  apps: Array<App>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isTwoFactorEnabled: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: Role;
  username: Scalars['String']['output'];
};

export enum LoginChallenge {
  AdminNoSrpAuth = 'ADMIN_NO_SRP_AUTH',
  CustomChallenge = 'CUSTOM_CHALLENGE',
  DevicePasswordVerifier = 'DEVICE_PASSWORD_VERIFIER',
  DeviceSrpAuth = 'DEVICE_SRP_AUTH',
  MfaSetup = 'MFA_SETUP',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  PasswordVerifier = 'PASSWORD_VERIFIER',
  SelectMfaType = 'SELECT_MFA_TYPE',
  SmsMfa = 'SMS_MFA',
  SoftwareTokenMfa = 'SOFTWARE_TOKEN_MFA'
}

export type LoginCodeScreen = {
  __typename?: 'LoginCodeScreen';
  backgroundImage?: Maybe<Image>;
  pollingIntervalSeconds?: Maybe<Scalars['Int']['output']>;
  qrCode?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  authenticationResult?: Maybe<AuthenticationResult>;
  challengeName?: Maybe<LoginChallenge>;
  challengeParameters?: Maybe<Scalars['JSON']['output']>;
  session?: Maybe<Scalars['String']['output']>;
};

export type LoginScreen = {
  __typename?: 'LoginScreen';
  backgroundImage?: Maybe<Image>;
};

export type LogoutConfirmationScreen = {
  __typename?: 'LogoutConfirmationScreen';
  backgroundImage?: Maybe<Image>;
};

export type ManageSubscriptionScreen = {
  __typename?: 'ManageSubscriptionScreen';
  backgroundImage?: Maybe<Image>;
};

export type MovieDetailScreen = {
  __typename?: 'MovieDetailScreen';
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: Maybe<Image>;
  secondaryBackgroundImage?: Maybe<Image>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abandonAppStagedChanges: Scalars['String']['output'];
  addConfigIntegration: Scalars['ID']['output'];
  addNavBarItem: NavBarItem;
  addPlatformToApp: App;
  cancelAccountDeletionRequest: Account;
  cancelAppDeletionRequest: App;
  cancelAppPlatformDeletionRequest: DeletionResult;
  confirmResetPassword: Scalars['String']['output'];
  createAccount: Account;
  createApp: App;
  createFeed: CreatedFeed;
  createScreen: CreatedScreen;
  createScreenFeed: ScreenFeed;
  createSubscriptionProduct: SubscriptionProduct;
  createUser: User;
  deleteAccount: DeletionResult;
  deleteApp: DeletionResult;
  deleteAppPlatform: DeletionResult;
  deleteConfigIntegration: Scalars['ID']['output'];
  deleteFeed?: Maybe<Scalars['ID']['output']>;
  deleteNavBarItem?: Maybe<Scalars['ID']['output']>;
  deleteScreen?: Maybe<Scalars['ID']['output']>;
  deleteScreenFeed?: Maybe<Scalars['ID']['output']>;
  deleteSubscriptionProduct?: Maybe<Scalars['ID']['output']>;
  deleteUser: Scalars['String']['output'];
  login: LoginResult;
  logout: Scalars['String']['output'];
  publishAppStagingToProduction: Scalars['String']['output'];
  refreshTokenLogin: LoginResult;
  resendInvite: Scalars['String']['output'];
  resetPassword: ForgotPasswordResponse;
  resetThemeEnvironmentToDefaultValues: Theme;
  respondToAuthChallenge: LoginResult;
  setLocalizedTranslations: Scalars['Boolean']['output'];
  setNavBarOrder: Scalars['Boolean']['output'];
  submitProductConsent: Scalars['String']['output'];
  triggerConfigWrite: Scalars['String']['output'];
  updateAccount: Account;
  updateApp: App;
  updateConfigIntegration: Scalars['ID']['output'];
  updateFeedEnvironment: Feed;
  updateFlowConfig: FlowConfig;
  updateLocalizedTranslations: Scalars['Boolean']['output'];
  updateMFAPreference: Scalars['String']['output'];
  updateNavBarItem: NavBarItem;
  updateScreenEnvironment: Screen;
  updateScreenFeed: ScreenFeed;
  updateSubscriptionProduct: SubscriptionProduct;
  updateThemeEnvironment: Theme;
  updateUser: User;
  validateSession: Scalars['Boolean']['output'];
};


export type MutationAbandonAppStagedChangesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddConfigIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: FlowConfigAddUpdateIntegrationInput;
};


export type MutationAddNavBarItemArgs = {
  configId: Scalars['ID']['input'];
  input: CreateNavBarItemInput;
};


export type MutationAddPlatformToAppArgs = {
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
};


export type MutationCancelAccountDeletionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelAppDeletionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelAppPlatformDeletionRequestArgs = {
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
};


export type MutationConfirmResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAppArgs = {
  accountId: Scalars['ID']['input'];
  input: CreateAppInput;
};


export type MutationCreateFeedArgs = {
  appId: Scalars['ID']['input'];
  input: CreateFeedInput;
};


export type MutationCreateScreenArgs = {
  appId: Scalars['ID']['input'];
  input: CreateScreenInput;
};


export type MutationCreateScreenFeedArgs = {
  input: CreateScreenFeedInput;
};


export type MutationCreateSubscriptionProductArgs = {
  configId: Scalars['ID']['input'];
  input: CreateSubscriptionProductInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppPlatformArgs = {
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
};


export type MutationDeleteConfigIntegrationArgs = {
  id: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type MutationDeleteFeedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNavBarItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScreenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScreenFeedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
  isHardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPublishAppStagingToProductionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefreshTokenLoginArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationResendInviteArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetThemeEnvironmentToDefaultValuesArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
};


export type MutationRespondToAuthChallengeArgs = {
  input: RespondToAuthChallengeInput;
};


export type MutationSetLocalizedTranslationsArgs = {
  appId: Scalars['ID']['input'];
  environment: Environment;
  input: SetLocalizedTranslationsInput;
  localeCode: Scalars['String']['input'];
  namespace: LocalizationNamespace;
};


export type MutationSetNavBarOrderArgs = {
  configId: Scalars['ID']['input'];
  input: SetNavBarOrderInput;
};


export type MutationTriggerConfigWriteArgs = {
  appId: Scalars['ID']['input'];
  environment: Environment;
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};


export type MutationUpdateAppArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAppInput;
};


export type MutationUpdateConfigIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: FlowConfigAddUpdateIntegrationInput;
};


export type MutationUpdateFeedEnvironmentArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
  input: UpdateFeedEnvironmentInput;
};


export type MutationUpdateFlowConfigArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFlowConfigInput;
};


export type MutationUpdateLocalizedTranslationsArgs = {
  appId: Scalars['ID']['input'];
  environment: Environment;
  input: UpdateLocalizedTranslationsInput;
  localeCode: Scalars['String']['input'];
  namespace: LocalizationNamespace;
};


export type MutationUpdateMfaPreferenceArgs = {
  phoneNumber: Scalars['String']['input'];
  useMFA: Scalars['Boolean']['input'];
};


export type MutationUpdateNavBarItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNavBarItemInput;
};


export type MutationUpdateScreenEnvironmentArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
  input: UpdateScreenInput;
};


export type MutationUpdateScreenFeedArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScreenFeedInput;
};


export type MutationUpdateSubscriptionProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionProductInput;
};


export type MutationUpdateThemeEnvironmentArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
  input: UpdateThemeInput;
};


export type MutationUpdateUserArgs = {
  email: Scalars['String']['input'];
  input: UpdateUserInput;
};


export type MutationValidateSessionArgs = {
  session: Scalars['String']['input'];
};

export type NavBarItem = {
  __typename?: 'NavBarItem';
  config: FlowConfig;
  context?: Maybe<Scalars['JSON']['output']>;
  icon: Image;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  requireAuthenticated: Scalars['Boolean']['output'];
  requireSubscribed: Scalars['Boolean']['output'];
  screen?: Maybe<Screen>;
  screenType: ScreenType;
};

export type NewDeviceMetadata = {
  __typename?: 'NewDeviceMetadata';
  deviceGroupKey?: Maybe<Scalars['String']['output']>;
  deviceKey?: Maybe<Scalars['String']['output']>;
};

export type NewPasswordRequiredResponseInput = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type PaginatedFeedSet = {
  __typename?: 'PaginatedFeedSet';
  edges: Array<FeedEdge>;
  pageInfo: PaginationInfo;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type ParentalPinForgotScreen = {
  __typename?: 'ParentalPinForgotScreen';
  backgroundImage?: Maybe<Image>;
};

export type ParentalPinForgotSetScreen = {
  __typename?: 'ParentalPinForgotSetScreen';
  backgroundImage?: Maybe<Image>;
};

export type ParentalPinScreen = {
  __typename?: 'ParentalPinScreen';
  backgroundImage?: Maybe<Image>;
};

export type ParentalPinSetScreen = {
  __typename?: 'ParentalPinSetScreen';
  backgroundImage?: Maybe<Image>;
};

export type PaywallScreen = {
  __typename?: 'PaywallScreen';
  backgroundImage?: Maybe<Image>;
};

export type Platform = {
  __typename?: 'Platform';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PlaylistDetailScreen = {
  __typename?: 'PlaylistDetailScreen';
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: Maybe<Image>;
  secondaryBackgroundImage?: Maybe<Image>;
};

export type PrivacyConsentScreen = {
  __typename?: 'PrivacyConsentScreen';
  backgroundImage?: Maybe<Image>;
};

export type PrivacyPolicyScreen = {
  __typename?: 'PrivacyPolicyScreen';
  backgroundImage?: Maybe<Image>;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accounts: Array<Account>;
  app: App;
  apps: Array<App>;
  configStatus: GenerationStatus;
  feed: Feed;
  feedsByApp: PaginatedFeedSet;
  file: File;
  files: Array<File>;
  flowConfig: FlowConfig;
  getAllAppsStatuses: Array<AllStatus>;
  getStatusByStatusId: CompleteStatus;
  images: Array<Image>;
  integration: Integration;
  integrations: Array<Integration>;
  localizedTranslations: Array<LocalizedTranslation>;
  loggedInUser: LoggedInUser;
  navBarItem: NavBarItem;
  navBarItems: Array<NavBarItem>;
  platform?: Maybe<Platform>;
  platforms: Array<Platform>;
  screen: Screen;
  screenFeed?: Maybe<ScreenFeed>;
  screenFeedByScreenAndFeedIds?: Maybe<ScreenFeed>;
  screenFeeds: Array<ScreenFeed>;
  screens: Array<Screen>;
  subscriptionProduct: SubscriptionProduct;
  subscriptionProducts: Array<SubscriptionProduct>;
  theme?: Maybe<Theme>;
  usedIntegrationByApp: UsedIntegration;
  user: User;
  users: Array<User>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConfigStatusArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
};


export type QueryFeedArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
};


export type QueryFeedsByAppArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appId: Scalars['ID']['input'];
  environment?: InputMaybe<Environment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFileArgs = {
  key: Scalars['String']['input'];
};


export type QueryFlowConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllAppsStatusesArgs = {
  environment: Environment;
};


export type QueryGetStatusByStatusIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgs = {
  accountId: Scalars['ID']['input'];
  type: ImageType;
};


export type QueryIntegrationArgs = {
  key: Scalars['String']['input'];
};


export type QueryIntegrationsArgs = {
  types?: InputMaybe<Array<IntegrationType>>;
};


export type QueryLocalizedTranslationsArgs = {
  appId: Scalars['ID']['input'];
  environment: Environment;
  localeCode: Scalars['String']['input'];
  namespace: LocalizationNamespace;
};


export type QueryNavBarItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNavBarItemsArgs = {
  configId: Scalars['ID']['input'];
};


export type QueryPlatformArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScreenArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
};


export type QueryScreenFeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScreenFeedByScreenAndFeedIdsArgs = {
  environment: Environment;
  feedId: Scalars['ID']['input'];
  screenId: Scalars['ID']['input'];
};


export type QueryScreenFeedsArgs = {
  environment: Environment;
  screenId: Scalars['ID']['input'];
};


export type QueryScreensArgs = {
  appId: Scalars['ID']['input'];
  environment: Environment;
};


export type QuerySubscriptionProductArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionProductsArgs = {
  configId: Scalars['ID']['input'];
};


export type QueryThemeArgs = {
  environment: Environment;
  id: Scalars['ID']['input'];
};


export type QueryUsedIntegrationByAppArgs = {
  appId: Scalars['ID']['input'];
  environment?: InputMaybe<Environment>;
  feedId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  username: Scalars['String']['input'];
};

export type RecommendationsChannelScreen = {
  __typename?: 'RecommendationsChannelScreen';
  icon: Image;
};

export type RegisterScreen = {
  __typename?: 'RegisterScreen';
  backgroundImage?: Maybe<Image>;
  passwordLowercase: Scalars['Boolean']['output'];
  passwordMinCharacters: Scalars['Int']['output'];
  passwordNonAlphanumeric: Scalars['Boolean']['output'];
  passwordNumber: Scalars['Boolean']['output'];
  passwordUppercase: Scalars['Boolean']['output'];
};

export type RespondToAuthChallengeInput = {
  challengeName: LoginChallenge;
  newPasswordRequiredResponse?: InputMaybe<NewPasswordRequiredResponseInput>;
  session: Scalars['String']['input'];
  smsMFAInput?: InputMaybe<SmsmfaInput>;
};

export enum Role {
  AppAdmin = 'APP_ADMIN',
  AppUser = 'APP_USER',
  SystemAdmin = 'SYSTEM_ADMIN'
}

export type SmsmfaInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type Screen = {
  __typename?: 'Screen';
  accountScreen?: Maybe<AccountScreen>;
  allowAppRefresh: Scalars['Boolean']['output'];
  appExitScreen?: Maybe<AppExitScreen>;
  appSettingsScreen?: Maybe<AppSettingsScreen>;
  areYouStillWatchingScreen?: Maybe<AreYouStillWatchingScreen>;
  audioPlaybackScreen?: Maybe<AudioPlaybackScreen>;
  browseBScreen?: Maybe<BrowseBScreen>;
  browseCScreen?: Maybe<BrowseCScreen>;
  browseDScreen?: Maybe<BrowseDScreen>;
  browseScreen?: Maybe<BrowseScreen>;
  ccpaPrivacyScreen?: Maybe<CcpaPrivacyScreen>;
  continueWatchingScreen?: Maybe<ContinueWatchingScreen>;
  createdAt: Scalars['Date']['output'];
  deleteAccountConfirmationScreen?: Maybe<DeleteAccountConfirmationScreen>;
  deleteAccountScreen?: Maybe<DeleteAccountScreen>;
  environment: Environment;
  errorScreen?: Maybe<ErrorScreen>;
  faqScreen?: Maybe<FaqScreen>;
  favoritesScreen?: Maybe<FavoritesScreen>;
  forceUpdateScreen?: Maybe<ForceUpdateScreen>;
  forgotPasswordConfirmationScreen?: Maybe<ForgotPasswordConfirmationScreen>;
  forgotPasswordExternalScreen?: Maybe<ForgotPasswordExternalScreen>;
  forgotPasswordScreen?: Maybe<ForgotPasswordScreen>;
  homeMiniPlayerScreen?: Maybe<HomeMiniPlayerScreen>;
  homeScreen?: Maybe<HomeScreen>;
  id: Scalars['ID']['output'];
  localization: Array<LocalizedTranslation>;
  loginCodeScreen?: Maybe<LoginCodeScreen>;
  loginScreen?: Maybe<LoginScreen>;
  logoutConfirmationScreen?: Maybe<LogoutConfirmationScreen>;
  manageSubscriptionScreen?: Maybe<ManageSubscriptionScreen>;
  movieDetailScreen?: Maybe<MovieDetailScreen>;
  name: Scalars['String']['output'];
  parentalPinForgotScreen?: Maybe<ParentalPinForgotScreen>;
  parentalPinForgotSetScreen?: Maybe<ParentalPinForgotSetScreen>;
  parentalPinScreen?: Maybe<ParentalPinScreen>;
  parentalPinSetScreen?: Maybe<ParentalPinSetScreen>;
  paywallScreen?: Maybe<PaywallScreen>;
  platforms: Array<Platform>;
  playlistDetailScreen?: Maybe<PlaylistDetailScreen>;
  privacyConsentScreen?: Maybe<PrivacyConsentScreen>;
  privacyPolicyScreen?: Maybe<PrivacyPolicyScreen>;
  recommendationsChannelScreen?: Maybe<RecommendationsChannelScreen>;
  registerScreen?: Maybe<RegisterScreen>;
  screenFeeds: Array<ScreenFeed>;
  searchScreen?: Maybe<SearchScreen>;
  seriesDetailScreen?: Maybe<SeriesDetailScreen>;
  splashScreen?: Maybe<SplashScreen>;
  supportScreen?: Maybe<SupportScreen>;
  termsPurchaseScreen?: Maybe<TermsPurchaseScreen>;
  termsServiceScreen?: Maybe<TermsServiceScreen>;
  thirdPartySoftwareScreen?: Maybe<ThirdPartySoftwareScreen>;
  type: ScreenType;
  upsellScreen?: Maybe<UpsellScreen>;
  videoPlaybackScreen?: Maybe<VideoPlaybackScreen>;
  welcomePrivacyConsentScreen?: Maybe<WelcomePrivacyConsentScreen>;
  welcomeScreen?: Maybe<WelcomeScreen>;
};


export type ScreenLocalizationArgs = {
  environment: Environment;
  locale: Scalars['String']['input'];
};


export type ScreenPlatformsArgs = {
  environment: Environment;
};

export enum ScreenAction {
  Detail = 'DETAIL',
  LoadCategory = 'LOAD_CATEGORY',
  Playback = 'PLAYBACK'
}

export type ScreenFeed = {
  __typename?: 'ScreenFeed';
  action: ScreenAction;
  feed: Feed;
  id: Scalars['ID']['output'];
  itemLayout: ScreenItemLayout;
  layout: ScreenLayout;
  order: Scalars['Int']['output'];
  refreshPolicy: ScreenFeedRefreshPolicy;
  rowItemPageSize: Scalars['Int']['output'];
  rowPageSize: Scalars['Int']['output'];
  screen: Screen;
  title?: Maybe<Scalars['String']['output']>;
};


export type ScreenFeedFeedArgs = {
  environment: Environment;
};

export type ScreenFeedRefreshPolicy = {
  __typename?: 'ScreenFeedRefreshPolicy';
  refreshIntervalSeconds: Scalars['Int']['output'];
  refreshOnScreenResume: Scalars['Boolean']['output'];
};

export enum ScreenItemLayout {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Square = 'SQUARE'
}

export enum ScreenLayout {
  Grid = 'GRID',
  Row = 'ROW'
}

export enum ScreenType {
  Account = 'ACCOUNT',
  AppExit = 'APP_EXIT',
  AppSettings = 'APP_SETTINGS',
  AreYouStillWatching = 'ARE_YOU_STILL_WATCHING',
  AudioPlayback = 'AUDIO_PLAYBACK',
  Browse = 'BROWSE',
  BrowseB = 'BROWSE_B',
  BrowseC = 'BROWSE_C',
  BrowseD = 'BROWSE_D',
  CcpaPrivacy = 'CCPA_PRIVACY',
  ContinueWatching = 'CONTINUE_WATCHING',
  DeleteAccount = 'DELETE_ACCOUNT',
  DeleteAccountConfirmation = 'DELETE_ACCOUNT_CONFIRMATION',
  Error = 'ERROR',
  Faq = 'FAQ',
  Favorites = 'FAVORITES',
  ForceUpdate = 'FORCE_UPDATE',
  ForgotPassword = 'FORGOT_PASSWORD',
  ForgotPasswordConfirmation = 'FORGOT_PASSWORD_CONFIRMATION',
  ForgotPasswordExternal = 'FORGOT_PASSWORD_EXTERNAL',
  Home = 'HOME',
  HomeMiniPlayer = 'HOME_MINI_PLAYER',
  Login = 'LOGIN',
  LoginCode = 'LOGIN_CODE',
  LogoutConfirmation = 'LOGOUT_CONFIRMATION',
  ManageSubscription = 'MANAGE_SUBSCRIPTION',
  MovieDetail = 'MOVIE_DETAIL',
  ParentalPin = 'PARENTAL_PIN',
  ParentalPinForgot = 'PARENTAL_PIN_FORGOT',
  ParentalPinForgotSet = 'PARENTAL_PIN_FORGOT_SET',
  ParentalPinSet = 'PARENTAL_PIN_SET',
  Paywall = 'PAYWALL',
  PlaylistDetail = 'PLAYLIST_DETAIL',
  PrivacyConsent = 'PRIVACY_CONSENT',
  PrivacyPolicy = 'PRIVACY_POLICY',
  RecommendationsChannel = 'RECOMMENDATIONS_CHANNEL',
  Register = 'REGISTER',
  Search = 'SEARCH',
  SeriesDetail = 'SERIES_DETAIL',
  Splash = 'SPLASH',
  Support = 'SUPPORT',
  TermsPurchase = 'TERMS_PURCHASE',
  TermsService = 'TERMS_SERVICE',
  ThirdPartySoftware = 'THIRD_PARTY_SOFTWARE',
  Upsell = 'UPSELL',
  VideoPlayback = 'VIDEO_PLAYBACK',
  Welcome = 'WELCOME',
  WelcomePrivacyConsent = 'WELCOME_PRIVACY_CONSENT'
}

export type Screen_ScreenFeedInput = {
  action: ScreenAction;
  feedId: Scalars['ID']['input'];
  itemLayout: ScreenItemLayout;
  layout: ScreenLayout;
  refreshIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  refreshOnScreenResume?: InputMaybe<Scalars['Boolean']['input']>;
  rowItemPageSize?: InputMaybe<Scalars['Int']['input']>;
  rowPageSize?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchScreen = {
  __typename?: 'SearchScreen';
  backgroundImage?: Maybe<Image>;
};

export type SeriesDetailScreen = {
  __typename?: 'SeriesDetailScreen';
  backgroundImageLayout: ImageLayout;
  primaryBackgroundImage?: Maybe<Image>;
  secondaryBackgroundImage?: Maybe<Image>;
};

export type SetLocalizedTranslationsInput = {
  allTranslations: Array<UpdateLocalizedTranslationInput>;
};

export type SetNavBarOrderInput = {
  navBarOrder: Array<Scalars['String']['input']>;
};

export type SplashScreen = {
  __typename?: 'SplashScreen';
  backgroundImage: Image;
};

export enum Status {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Published = 'PUBLISHED'
}

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flowConfig: FlowConfig;
  id: Scalars['ID']['output'];
  isInUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type SupportScreen = {
  __typename?: 'SupportScreen';
  backgroundImage?: Maybe<Image>;
};

export type TermsPurchaseScreen = {
  __typename?: 'TermsPurchaseScreen';
  backgroundImage?: Maybe<Image>;
};

export type TermsServiceScreen = {
  __typename?: 'TermsServiceScreen';
  backgroundImage?: Maybe<Image>;
};

export type Theme = {
  __typename?: 'Theme';
  app: App;
  colors: ThemeColors;
  environment: Environment;
  id: Scalars['ID']['output'];
  landscapeFallback?: Maybe<Image>;
  logo: Image;
  portraitFallback?: Maybe<Image>;
  premiumIcon?: Maybe<Image>;
  squareFallback?: Maybe<Image>;
};

export type ThemeColors = {
  __typename?: 'ThemeColors';
  background: Scalars['String']['output'];
  badge: Scalars['String']['output'];
  button: Scalars['String']['output'];
  buttonBorder: Scalars['String']['output'];
  buttonFocused: Scalars['String']['output'];
  buttonFocusedBorder: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonTextFocused: Scalars['String']['output'];
  cardFocusedBorder: Scalars['String']['output'];
  cardPlaceholder: Scalars['String']['output'];
  loadingIndicator: Scalars['String']['output'];
  navBarBackground: Scalars['String']['output'];
  overlay: Scalars['String']['output'];
  progress: Scalars['String']['output'];
  separator: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textInput: Scalars['String']['output'];
  textInputBorder: Scalars['String']['output'];
  textInputFocused: Scalars['String']['output'];
  textInputFocusedBorder: Scalars['String']['output'];
  textSecondary: Scalars['String']['output'];
  underline: Scalars['String']['output'];
};

export type ThirdPartySoftwareScreen = {
  __typename?: 'ThirdPartySoftwareScreen';
  backgroundImage?: Maybe<Image>;
};

export type UpdateAccountInput = {
  ensembleAccountManagerName: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
  primaryContactPhone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateAccountScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppExitScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppInput = {
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppSettingsScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAreYouStillWatchingScreenInput = {
  countdown?: InputMaybe<Scalars['Int']['input']>;
  inactivityInterval?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAudioPlaybackScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  imageLayout?: InputMaybe<ImageLayout>;
  progressHeartbeat?: InputMaybe<Scalars['Int']['input']>;
  upNextCountdown?: InputMaybe<Scalars['Int']['input']>;
  upNextCue?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBrowseBScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrowseCScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrowseDScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrowseScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCcpaPrivacyScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContinueWatchingScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeleteAccountConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeleteAccountScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateErrorScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFaqScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFavoritesScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeedEnvironmentInput = {
  contentDetailIntegrationKey: Scalars['String']['input'];
  contentIntegrationKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nested: Scalars['Boolean']['input'];
  type: FeedType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFlowConfigInput = {
  certificationStatus?: InputMaybe<CertificationStatus>;
  features?: InputMaybe<Array<Feature>>;
  flowVersion?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<FlowConfigIntegrationInput>>;
  minSDKVersion?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  screenIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateForceUpdateScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateForgotPasswordConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateForgotPasswordExternalScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateForgotPasswordScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeMiniPlayerScreenInput = {
  autoFullScreenTransition?: InputMaybe<Scalars['Int']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  backgroundImageLayout?: InputMaybe<ImageLayout>;
};

export type UpdateLocalizedTranslationInput = {
  key: Scalars['String']['input'];
  translation: Scalars['String']['input'];
};

export type UpdateLocalizedTranslationsInput = {
  updates: Array<UpdateLocalizedTranslationInput>;
};

export type UpdateLoginCodeScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  pollingIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  qrCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLoginScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLogoutConfirmationScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManageSubscriptionScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMovieDetailScreenInput = {
  backgroundImageLayout?: InputMaybe<ImageLayout>;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNavBarItemInput = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  iconKey?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  requireAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  requireSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateParentalPinForgotScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParentalPinForgotSetScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParentalPinScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParentalPinSetScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaywallScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaylistDetailScreenInput = {
  backgroundImageLayout?: InputMaybe<ImageLayout>;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrivacyConsentScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrivacyPolicyScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecommendationsChannelScreenInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegisterScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  passwordLowercase?: InputMaybe<Scalars['Boolean']['input']>;
  passwordMinCharacters?: InputMaybe<Scalars['Int']['input']>;
  passwordNonAlphanumeric?: InputMaybe<Scalars['Boolean']['input']>;
  passwordNumber?: InputMaybe<Scalars['Boolean']['input']>;
  passwordUppercase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateScreenFeedInput = {
  action?: InputMaybe<ScreenAction>;
  itemLayout?: InputMaybe<ScreenItemLayout>;
  layout?: InputMaybe<ScreenLayout>;
  order?: InputMaybe<Scalars['Int']['input']>;
  refreshPolicy?: InputMaybe<UpdateScreenFeedRefreshPolicyInput>;
  rowItemPageSize?: InputMaybe<Scalars['Int']['input']>;
  rowPageSize?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScreenFeedRefreshPolicyInput = {
  refreshIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  refreshOnScreenResume?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateScreenInput = {
  account?: InputMaybe<UpdateAccountScreenInput>;
  allowAppRefresh: Scalars['Boolean']['input'];
  appExit?: InputMaybe<UpdateAppExitScreenInput>;
  appSettings?: InputMaybe<UpdateAppSettingsScreenInput>;
  areYouStillWatching?: InputMaybe<UpdateAreYouStillWatchingScreenInput>;
  audioPlayback?: InputMaybe<UpdateAudioPlaybackScreenInput>;
  browse?: InputMaybe<UpdateBrowseScreenInput>;
  browseB?: InputMaybe<UpdateBrowseBScreenInput>;
  browseC?: InputMaybe<UpdateBrowseCScreenInput>;
  browseD?: InputMaybe<UpdateBrowseDScreenInput>;
  ccpaPrivacy?: InputMaybe<UpdateCcpaPrivacyScreenInput>;
  continueWatching?: InputMaybe<UpdateContinueWatchingScreenInput>;
  deleteAccount?: InputMaybe<UpdateDeleteAccountScreenInput>;
  deleteAccountConfirmation?: InputMaybe<UpdateDeleteAccountConfirmationScreenInput>;
  error?: InputMaybe<UpdateErrorScreenInput>;
  faq?: InputMaybe<UpdateFaqScreenInput>;
  favorites?: InputMaybe<UpdateFavoritesScreenInput>;
  forceUpdate?: InputMaybe<UpdateForceUpdateScreenInput>;
  forgotPassword?: InputMaybe<UpdateForgotPasswordScreenInput>;
  forgotPasswordConfirmation?: InputMaybe<UpdateForgotPasswordConfirmationScreenInput>;
  forgotPasswordExternal?: InputMaybe<UpdateForgotPasswordExternalScreenInput>;
  home?: InputMaybe<UpdateHomeScreenInput>;
  homeMiniPlayer?: InputMaybe<UpdateHomeMiniPlayerScreenInput>;
  login?: InputMaybe<UpdateLoginScreenInput>;
  loginCode?: InputMaybe<UpdateLoginCodeScreenInput>;
  logoutConfirmation?: InputMaybe<UpdateLogoutConfirmationScreenInput>;
  manageSubscription?: InputMaybe<UpdateManageSubscriptionScreenInput>;
  movieDetail?: InputMaybe<UpdateMovieDetailScreenInput>;
  name: Scalars['String']['input'];
  parentalPin?: InputMaybe<UpdateParentalPinScreenInput>;
  parentalPinForgot?: InputMaybe<UpdateParentalPinForgotScreenInput>;
  parentalPinForgotSet?: InputMaybe<UpdateParentalPinForgotSetScreenInput>;
  parentalPinSet?: InputMaybe<UpdateParentalPinSetScreenInput>;
  paywall?: InputMaybe<UpdatePaywallScreenInput>;
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  playlistDetail?: InputMaybe<UpdatePlaylistDetailScreenInput>;
  privacyConsent?: InputMaybe<UpdatePrivacyConsentScreenInput>;
  privacyPolicy?: InputMaybe<UpdatePrivacyPolicyScreenInput>;
  recommendationsChannel?: InputMaybe<UpdateRecommendationsChannelScreenInput>;
  register?: InputMaybe<UpdateRegisterScreenInput>;
  screenFeeds?: InputMaybe<Array<Screen_ScreenFeedInput>>;
  search?: InputMaybe<UpdateSearchScreenInput>;
  seriesDetail?: InputMaybe<UpdateSeriesDetailScreenInput>;
  splash?: InputMaybe<UpdateSplashScreenInput>;
  support?: InputMaybe<UpdateSupportScreenInput>;
  termsPurchase?: InputMaybe<UpdateTermsPurchaseScreenInput>;
  termsService?: InputMaybe<UpdateTermsServiceScreenInput>;
  thirdPartySoftware?: InputMaybe<UpdateThirdPartySoftwareScreenInput>;
  translations?: InputMaybe<Array<UpdateLocalizedTranslationInput>>;
  upsell?: InputMaybe<UpdateUpsellScreenInput>;
  videoPlayback?: InputMaybe<UpdateVideoPlaybackScreenInput>;
  welcome?: InputMaybe<UpdateWelcomeScreenInput>;
  welcomePrivacyConsent?: InputMaybe<UpdateWelcomePrivacyConsentScreenInput>;
};

export type UpdateSearchScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSeriesDetailScreenInput = {
  backgroundImageLayout?: InputMaybe<ImageLayout>;
  primaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSplashScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isInUse?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupportScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTermsPurchaseScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTermsServiceScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThemeColorsInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<Scalars['String']['input']>;
  buttonBorder?: InputMaybe<Scalars['String']['input']>;
  buttonFocused?: InputMaybe<Scalars['String']['input']>;
  buttonFocusedBorder?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonTextFocused?: InputMaybe<Scalars['String']['input']>;
  cardFocusedBorder?: InputMaybe<Scalars['String']['input']>;
  cardPlaceholder?: InputMaybe<Scalars['String']['input']>;
  loadingIndicator?: InputMaybe<Scalars['String']['input']>;
  navBarBackground?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textInput?: InputMaybe<Scalars['String']['input']>;
  textInputBorder?: InputMaybe<Scalars['String']['input']>;
  textInputFocused?: InputMaybe<Scalars['String']['input']>;
  textInputFocusedBorder?: InputMaybe<Scalars['String']['input']>;
  textSecondary?: InputMaybe<Scalars['String']['input']>;
  underline?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThemeInput = {
  colors?: InputMaybe<UpdateThemeColorsInput>;
  landscapeFallbackKey?: InputMaybe<Scalars['String']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  portraitFallbackKey?: InputMaybe<Scalars['String']['input']>;
  premiumIconKey?: InputMaybe<Scalars['String']['input']>;
  squareFallbackKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThirdPartySoftwareScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUpsellScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
};

export type UpdateVideoPlaybackScreenInput = {
  imageLayout?: InputMaybe<ImageLayout>;
  prerollAdFrequency?: InputMaybe<Scalars['Int']['input']>;
  progressHeartbeat?: InputMaybe<Scalars['Int']['input']>;
  upNextCountdown?: InputMaybe<Scalars['Int']['input']>;
  upNextCue?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWelcomePrivacyConsentScreenInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWelcomeScreenInput = {
  alwaysShowOnLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
};

export type UpsellScreen = {
  __typename?: 'UpsellScreen';
  backgroundImage?: Maybe<Image>;
};

export type UsedIntegration = {
  __typename?: 'UsedIntegration';
  usedContentDetailIntegration: Array<Scalars['String']['output']>;
  usedContentIntegration: Array<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  apps: Array<App>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  hasCompletedRegistration: Scalars['Boolean']['output'];
  isTwoFactorEnabled: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: Role;
  username: Scalars['String']['output'];
};

export type VideoPlaybackScreen = {
  __typename?: 'VideoPlaybackScreen';
  imageLayout?: Maybe<ImageLayout>;
  prerollAdFrequency?: Maybe<Scalars['Int']['output']>;
  progressHeartbeat: Scalars['Int']['output'];
  upNextCountdown: Scalars['Int']['output'];
  upNextCue?: Maybe<Scalars['Int']['output']>;
};

export type WelcomePrivacyConsentScreen = {
  __typename?: 'WelcomePrivacyConsentScreen';
  backgroundImage?: Maybe<Image>;
};

export type WelcomeScreen = {
  __typename?: 'WelcomeScreen';
  alwaysShowOnLaunch?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Image>;
};

export type AccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, createdAt: any, name: string, url: string, primaryContactName: string, primaryContactEmail: string, primaryContactPhone: string, ensembleAccountManagerName: string, deletionRequestingUser?: { __typename?: 'User', username: string, firstName: string, lastName: string, email: string } | null }> };

export type AccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', name: string, url: string, primaryContactName: string, primaryContactEmail: string, primaryContactPhone: string, ensembleAccountManagerName: string } };

export type AccountNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountNameQuery = { __typename?: 'Query', account: { __typename?: 'Account', name: string } };

export type CreateAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactPhone: Scalars['String']['input'];
  ensembleAccountManagerName: Scalars['String']['input'];
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string } };

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactPhone: Scalars['String']['input'];
  ensembleAccountManagerName: Scalars['String']['input'];
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: DeletionResult };

export type RemoveDeleteAccountRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDeleteAccountRequestMutation = { __typename?: 'Mutation', cancelAccountDeletionRequest: { __typename?: 'Account', id: string } };

export type AllAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAppsQuery = { __typename?: 'Query', apps: Array<{ __typename?: 'App', id: string, name: string, createdAt: any, account: { __typename?: 'Account', name: string } }> };

export type AccountAppsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountAppsQuery = { __typename?: 'Query', apps: Array<{ __typename?: 'App', id: string, name: string, createdAt: any, website?: string | null }> };

export type AppQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
}>;


export type AppQuery = { __typename?: 'Query', app: { __typename?: 'App', name: string, website?: string | null, lastPublished: any, account: { __typename?: 'Account', id: string, name: string }, platforms: Array<{ __typename?: 'AppPlatform', id: string, name: string }>, theme: { __typename?: 'Theme', logo: { __typename?: 'Image', url: string } }, status: { __typename?: 'GenerationStatus', state?: Status | null } } };

export type AppDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
}>;


export type AppDetailQuery = { __typename?: 'Query', app: { __typename?: 'App', name: string, website?: string | null, lastPublished: any, account: { __typename?: 'Account', id: string, name: string, ensembleAccountManagerName: string }, platforms: Array<{ __typename?: 'AppPlatform', id: string, name: string }>, theme: { __typename?: 'Theme', logo: { __typename?: 'Image', url: string } }, deletionRequestingUser?: { __typename?: 'User', username: string, firstName: string, lastName: string, email: string } | null, status: { __typename?: 'GenerationStatus', state?: Status | null } } };

export type GenerationStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
}>;


export type GenerationStatusQuery = { __typename?: 'Query', configStatus: { __typename?: 'GenerationStatus', state?: Status | null, logs: Array<{ __typename?: 'FormatedLog', message: string }> } };

export type AppsStatusesQueryVariables = Exact<{
  environment: Environment;
}>;


export type AppsStatusesQuery = { __typename?: 'Query', getAllAppsStatuses: Array<{ __typename?: 'AllStatus', id: string, account: string, app: string, appId: string, environment: string, status: Status, createdAt: any, lastSuccessfulDate?: any | null }> };

export type StatusDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StatusDetailQuery = { __typename?: 'Query', getStatusByStatusId: { __typename?: 'CompleteStatus', id: string, account: string, app: string, appId: string, environment: string, status: Status, createdAt: any, lastSuccessfulDate?: any | null, logs: Array<{ __typename?: 'FormatedLog', message: string }> } };

export type CreateAppMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: CreateAppInput;
}>;


export type CreateAppMutation = { __typename?: 'Mutation', createApp: { __typename?: 'App', id: string } };

export type UpdateAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAppInput;
}>;


export type UpdateAppMutation = { __typename?: 'Mutation', updateApp: { __typename?: 'App', id: string } };

export type DeleteAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAppMutation = { __typename?: 'Mutation', deleteApp: DeletionResult };

export type PublishAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishAppMutation = { __typename?: 'Mutation', publishAppStagingToProduction: string };

export type RevertAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevertAppMutation = { __typename?: 'Mutation', abandonAppStagedChanges: string };

export type TriggerConfigWriteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  env: Environment;
}>;


export type TriggerConfigWriteMutation = { __typename?: 'Mutation', triggerConfigWrite: string };

export type RemoveDeleteAppRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDeleteAppRequestMutation = { __typename?: 'Mutation', cancelAppDeletionRequest: { __typename?: 'App', id: string } };

export type AuthenticationDataFragment = { __typename?: 'LoginResult', challengeName?: LoginChallenge | null, challengeParameters?: any | null, session?: string | null, authenticationResult?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null } | null };

export type ResendRegistrationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendRegistrationMutation = { __typename?: 'Mutation', resendInvite: string };

export type ValidateSessionMutationVariables = Exact<{
  session: Scalars['String']['input'];
}>;


export type ValidateSessionMutation = { __typename?: 'Mutation', validateSession: boolean };

export type ResetPasswordRequestMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordRequestMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ForgotPasswordResponse', deliveryMedium?: DeliveryMedium | null, destination?: string | null } };

export type NewPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  session: Scalars['String']['input'];
}>;


export type NewPasswordMutation = { __typename?: 'Mutation', respondToAuthChallenge: { __typename?: 'LoginResult', challengeName?: LoginChallenge | null, challengeParameters?: any | null, session?: string | null, authenticationResult?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null } | null } };

export type ConfirmNewPasswordMutationVariables = Exact<{
  session: Scalars['String']['input'];
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ConfirmNewPasswordMutation = { __typename?: 'Mutation', confirmResetPassword: string };

export type VerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
  session: Scalars['String']['input'];
}>;


export type VerificationMutation = { __typename?: 'Mutation', respondToAuthChallenge: { __typename?: 'LoginResult', challengeName?: LoginChallenge | null, challengeParameters?: any | null, session?: string | null, authenticationResult?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResult', challengeName?: LoginChallenge | null, challengeParameters?: any | null, session?: string | null, authenticationResult?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null } | null } };

export type RefreshTokenLoginMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenLoginMutation = { __typename?: 'Mutation', refreshTokenLogin: { __typename?: 'LoginResult', authenticationResult?: { __typename?: 'AuthenticationResult', accessToken?: string | null } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: string };

export type SubmitProductConsentMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitProductConsentMutation = { __typename?: 'Mutation', submitProductConsent: string };

export type FeedsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment?: InputMaybe<Environment>;
}>;


export type FeedsQuery = { __typename?: 'Query', feedsByApp: { __typename?: 'PaginatedFeedSet', edges: Array<{ __typename?: 'FeedEdge', node: { __typename?: 'Feed', id: string, name: string, createdAt: any, type: FeedType, platforms: Array<{ __typename?: 'Platform', id: string, name: string }>, screenFeeds: Array<{ __typename?: 'ScreenFeed', id: string }> } }> } };

export type FeedQueryVariables = Exact<{
  feedId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type FeedQuery = { __typename?: 'Query', feed: { __typename?: 'Feed', id: string, name: string, description?: string | null, type: FeedType, url?: string | null, nested: boolean, contentIntegration: { __typename?: 'Integration', key: string }, contentDetailIntegration: { __typename?: 'Integration', key: string }, platforms: Array<{ __typename?: 'Platform', id: string, name: string }>, screenFeeds: Array<{ __typename?: 'ScreenFeed', screen: { __typename?: 'Screen', id: string, name: string } }> } };

export type UsedFeedIntegrationByAppQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
  environment?: InputMaybe<Environment>;
}>;


export type UsedFeedIntegrationByAppQuery = { __typename?: 'Query', usedIntegrationByApp: { __typename?: 'UsedIntegration', usedContentIntegration: Array<string>, usedContentDetailIntegration: Array<string> } };

export type CreateFeedMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  input: CreateFeedInput;
}>;


export type CreateFeedMutation = { __typename?: 'Mutation', createFeed: { __typename?: 'CreatedFeed', id: string } };

export type UpdateFeedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
  input: UpdateFeedEnvironmentInput;
}>;


export type UpdateFeedMutation = { __typename?: 'Mutation', updateFeedEnvironment: { __typename?: 'Feed', id: string } };

export type DeleteFeedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeedMutation = { __typename?: 'Mutation', deleteFeed?: string | null };

export type FileQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'File', key: string, url: string, filename: string, size: number } };

export type ImageLibraryQueryVariables = Exact<{
  type: ImageType;
  accountId: Scalars['ID']['input'];
}>;


export type ImageLibraryQuery = { __typename?: 'Query', images: Array<{ __typename?: 'Image', key: string, url: string, filename: string, size: number, mimeType: string }> };

export type IntegrationsQueryVariables = Exact<{
  types?: InputMaybe<Array<IntegrationType> | IntegrationType>;
}>;


export type IntegrationsQuery = { __typename?: 'Query', integrations: Array<{ __typename?: 'Integration', id: string, key: string, type: IntegrationType }> };

export type ConfigIntegrationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfigIntegrationsQuery = { __typename?: 'Query', flowConfig: { __typename?: 'FlowConfig', integrations: Array<{ __typename?: 'ConfigIntegration', settingsJson: any, createdAt: any, integration: { __typename?: 'Integration', id: string, key: string, type: IntegrationType } }> } };

export type SubmitIntegrationsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFlowConfigInput;
}>;


export type SubmitIntegrationsMutation = { __typename?: 'Mutation', updateFlowConfig: { __typename?: 'FlowConfig', id: string } };

export type AddIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: FlowConfigAddUpdateIntegrationInput;
}>;


export type AddIntegrationMutation = { __typename?: 'Mutation', addConfigIntegration: string };

export type UpdateIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: FlowConfigAddUpdateIntegrationInput;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateConfigIntegration: string };

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', deleteConfigIntegration: string };

export type LocalizedTranslationsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
  namespace: LocalizationNamespace;
  localeCode: Scalars['String']['input'];
}>;


export type LocalizedTranslationsQuery = { __typename?: 'Query', localizedTranslations: Array<{ __typename?: 'LocalizedTranslation', localeCode: string, key: string, value: string, isFallbackToDefault: boolean }> };

export type SetLocalizedTranslationsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
  namespace: LocalizationNamespace;
  localeCode: Scalars['String']['input'];
  input: SetLocalizedTranslationsInput;
}>;


export type SetLocalizedTranslationsMutation = { __typename?: 'Mutation', setLocalizedTranslations: boolean };

export type UpdateLocalizedTranslationsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
  namespace: LocalizationNamespace;
  localeCode: Scalars['String']['input'];
  input: UpdateLocalizedTranslationsInput;
}>;


export type UpdateLocalizedTranslationsMutation = { __typename?: 'Mutation', updateLocalizedTranslations: boolean };

export type NavBarItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NavBarItemQuery = { __typename?: 'Query', navBarItem: { __typename?: 'NavBarItem', id: string, label: string, screenType: ScreenType, requireAuthenticated: boolean, requireSubscribed: boolean, context?: any | null, icon: { __typename?: 'Image', key: string } } };

export type NavBarScreenTypesQueryVariables = Exact<{
  configId: Scalars['ID']['input'];
}>;


export type NavBarScreenTypesQuery = { __typename?: 'Query', navBarItems: Array<{ __typename?: 'NavBarItem', screenType: ScreenType }> };

export type CreateNavBarItemMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  input: CreateNavBarItemInput;
}>;


export type CreateNavBarItemMutation = { __typename?: 'Mutation', addNavBarItem: { __typename?: 'NavBarItem', id: string } };

export type UpdateNavBarItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNavBarItemInput;
}>;


export type UpdateNavBarItemMutation = { __typename?: 'Mutation', updateNavBarItem: { __typename?: 'NavBarItem', id: string } };

export type UpdateNavBarOrderMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  input: SetNavBarOrderInput;
}>;


export type UpdateNavBarOrderMutation = { __typename?: 'Mutation', setNavBarOrder: boolean };

export type DeleteNavBarItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNavBarItemMutation = { __typename?: 'Mutation', deleteNavBarItem?: string | null };

export type AllPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlatformsQuery = { __typename?: 'Query', platforms: Array<{ __typename?: 'Platform', id: string, name: string }> };

export type AppConfigsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type AppConfigsQuery = { __typename?: 'Query', app: { __typename?: 'App', configs: Array<{ __typename?: 'FlowConfig', flowVersion: string, deletionRequestingUser?: { __typename?: 'User', username: string, firstName: string, lastName: string } | null, platform: { __typename?: 'Platform', id: string }, lastModifiedByUser?: { __typename?: 'User', firstName: string, lastName: string } | null }>, platforms: Array<{ __typename?: 'AppPlatform', id: string, name: string, createdAt: any }> } };

export type ConfigQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ConfigQuery = { __typename?: 'Query', app: { __typename?: 'App', config: { __typename?: 'FlowConfig', id: string, name: string, minSDKVersion: string, certificationStatus: CertificationStatus, flowVersion: string, features: Array<Feature>, subscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', id: string, name: string, createdAt: any, description?: string | null, sku: string, isInUse: boolean }>, navBarItems: Array<{ __typename?: 'NavBarItem', id: string, screenType: ScreenType, label: string, requireAuthenticated: boolean, requireSubscribed: boolean, screen?: { __typename?: 'Screen', id: string, name: string } | null, icon: { __typename?: 'Image', filename: string, url: string } }>, integrations: Array<{ __typename?: 'ConfigIntegration', createdAt: any, integration: { __typename?: 'Integration', id: string, key: string, type: IntegrationType } }> } } };

export type ConfigIdQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ConfigIdQuery = { __typename?: 'Query', app: { __typename?: 'App', config: { __typename?: 'FlowConfig', id: string } } };

export type CreateAppPlatformMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
}>;


export type CreateAppPlatformMutation = { __typename?: 'Mutation', addPlatformToApp: { __typename?: 'App', id: string } };

export type UpdateConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFlowConfigInput;
}>;


export type UpdateConfigMutation = { __typename?: 'Mutation', updateFlowConfig: { __typename?: 'FlowConfig', id: string } };

export type DeleteAppPlatformMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
}>;


export type DeleteAppPlatformMutation = { __typename?: 'Mutation', deleteAppPlatform: DeletionResult };

export type ScreenFeedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ScreenFeedQuery = { __typename?: 'Query', screenFeed?: { __typename?: 'ScreenFeed', id: string, title?: string | null, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number, refreshPolicy: { __typename?: 'ScreenFeedRefreshPolicy', refreshOnScreenResume: boolean, refreshIntervalSeconds: number }, feed: { __typename?: 'Feed', id: string, name: string } } | null };

export type ScreenFeedsQueryVariables = Exact<{
  screenId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ScreenFeedsQuery = { __typename?: 'Query', screenFeeds: Array<{ __typename?: 'ScreenFeed', id: string, title?: string | null, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number, refreshPolicy: { __typename?: 'ScreenFeedRefreshPolicy', refreshOnScreenResume: boolean, refreshIntervalSeconds: number } }> };

export type ScreenFeedDetailQueryVariables = Exact<{
  screenId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ScreenFeedDetailQuery = { __typename?: 'Query', screenFeedByScreenAndFeedIds?: { __typename?: 'ScreenFeed', id: string, title?: string | null, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number, refreshPolicy: { __typename?: 'ScreenFeedRefreshPolicy', refreshOnScreenResume: boolean, refreshIntervalSeconds: number }, feed: { __typename?: 'Feed', id: string, name: string } } | null };

export type CreateScreenFeedMutationVariables = Exact<{
  input: CreateScreenFeedInput;
}>;


export type CreateScreenFeedMutation = { __typename?: 'Mutation', createScreenFeed: { __typename?: 'ScreenFeed', id: string, title?: string | null, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number } };

export type UpdateScreenFeedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateScreenFeedInput;
}>;


export type UpdateScreenFeedMutation = { __typename?: 'Mutation', updateScreenFeed: { __typename?: 'ScreenFeed', id: string, title?: string | null, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number } };

export type DeleteScreenFeedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScreenFeedMutation = { __typename?: 'Mutation', deleteScreenFeed?: string | null };

export type ScreensQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type ScreensQuery = { __typename?: 'Query', screens: Array<{ __typename?: 'Screen', id: string, name: string, createdAt: any, type: ScreenType, platforms: Array<{ __typename?: 'Platform', id: string, name: string }> }> };

export type ScreenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
  locale: Scalars['String']['input'];
}>;


export type ScreenQuery = { __typename?: 'Query', screen: { __typename?: 'Screen', id: string, type: ScreenType, name: string, allowAppRefresh: boolean, platforms: Array<{ __typename?: 'Platform', id: string, name: string }>, screenFeeds: Array<{ __typename?: 'ScreenFeed', id: string, order: number, layout: ScreenLayout, itemLayout: ScreenItemLayout, action: ScreenAction, rowItemPageSize: number, rowPageSize: number, feed: { __typename?: 'Feed', id: string, name: string }, refreshPolicy: { __typename?: 'ScreenFeedRefreshPolicy', refreshOnScreenResume: boolean, refreshIntervalSeconds: number } }>, localization: Array<{ __typename?: 'LocalizedTranslation', key: string, value: string, isFallbackToDefault: boolean }>, splashScreen?: { __typename?: 'SplashScreen', backgroundImage: { __typename?: 'Image', key: string, url: string } } | null, welcomeScreen?: { __typename?: 'WelcomeScreen', alwaysShowOnLaunch?: boolean | null, backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, loginScreen?: { __typename?: 'LoginScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, loginCodeScreen?: { __typename?: 'LoginCodeScreen', pollingIntervalSeconds?: number | null, qrCode?: boolean | null, backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, registerScreen?: { __typename?: 'RegisterScreen', passwordMinCharacters: number, passwordUppercase: boolean, passwordLowercase: boolean, passwordNumber: boolean, passwordNonAlphanumeric: boolean, backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, forgotPasswordScreen?: { __typename?: 'ForgotPasswordScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, forgotPasswordConfirmationScreen?: { __typename?: 'ForgotPasswordConfirmationScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, forgotPasswordExternalScreen?: { __typename?: 'ForgotPasswordExternalScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, homeScreen?: { __typename?: 'HomeScreen', backgroundImageLayout: ImageLayout, backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, browseScreen?: { __typename?: 'BrowseScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, browseBScreen?: { __typename?: 'BrowseBScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, browseCScreen?: { __typename?: 'BrowseCScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, browseDScreen?: { __typename?: 'BrowseDScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, favoritesScreen?: { __typename?: 'FavoritesScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, continueWatchingScreen?: { __typename?: 'ContinueWatchingScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, seriesDetailScreen?: { __typename?: 'SeriesDetailScreen', backgroundImageLayout: ImageLayout, primaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null, secondaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, movieDetailScreen?: { __typename?: 'MovieDetailScreen', backgroundImageLayout: ImageLayout, primaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null, secondaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, searchScreen?: { __typename?: 'SearchScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, audioPlaybackScreen?: { __typename?: 'AudioPlaybackScreen', progressHeartbeat: number, upNextCountdown: number, imageLayout: ImageLayout, upNextCue?: number | null, backgroundImage: { __typename?: 'Image', key: string, url: string } } | null, videoPlaybackScreen?: { __typename?: 'VideoPlaybackScreen', progressHeartbeat: number, upNextCountdown: number, upNextCue?: number | null, prerollAdFrequency?: number | null, imageLayout?: ImageLayout | null } | null, upsellScreen?: { __typename?: 'UpsellScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, paywallScreen?: { __typename?: 'PaywallScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, manageSubscriptionScreen?: { __typename?: 'ManageSubscriptionScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, accountScreen?: { __typename?: 'AccountScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, termsServiceScreen?: { __typename?: 'TermsServiceScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, termsPurchaseScreen?: { __typename?: 'TermsPurchaseScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, faqScreen?: { __typename?: 'FAQScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, privacyPolicyScreen?: { __typename?: 'PrivacyPolicyScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, ccpaPrivacyScreen?: { __typename?: 'CCPAPrivacyScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, thirdPartySoftwareScreen?: { __typename?: 'ThirdPartySoftwareScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, supportScreen?: { __typename?: 'SupportScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, recommendationsChannelScreen?: { __typename?: 'RecommendationsChannelScreen', icon: { __typename?: 'Image', key: string, url: string } } | null, forceUpdateScreen?: { __typename?: 'ForceUpdateScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, appExitScreen?: { __typename?: 'AppExitScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, logoutConfirmationScreen?: { __typename?: 'LogoutConfirmationScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, deleteAccountScreen?: { __typename?: 'DeleteAccountScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, deleteAccountConfirmationScreen?: { __typename?: 'DeleteAccountConfirmationScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, areYouStillWatchingScreen?: { __typename?: 'AreYouStillWatchingScreen', countdown: number, inactivityInterval: number } | null, errorScreen?: { __typename?: 'ErrorScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, privacyConsentScreen?: { __typename?: 'PrivacyConsentScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, appSettingsScreen?: { __typename?: 'AppSettingsScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, parentalPinScreen?: { __typename?: 'ParentalPinScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, parentalPinSetScreen?: { __typename?: 'ParentalPinSetScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, parentalPinForgotScreen?: { __typename?: 'ParentalPinForgotScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, homeMiniPlayerScreen?: { __typename?: 'HomeMiniPlayerScreen', autoFullScreenTransition: number, backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, parentalPinForgotSetScreen?: { __typename?: 'ParentalPinForgotSetScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, welcomePrivacyConsentScreen?: { __typename?: 'WelcomePrivacyConsentScreen', backgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null, playlistDetailScreen?: { __typename?: 'PlaylistDetailScreen', backgroundImageLayout: ImageLayout, primaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null, secondaryBackgroundImage?: { __typename?: 'Image', key: string, url: string } | null } | null } };

export type CreateScreenMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  input: CreateScreenInput;
}>;


export type CreateScreenMutation = { __typename?: 'Mutation', createScreen: { __typename?: 'CreatedScreen', id: string } };

export type UpdateScreenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
  input: UpdateScreenInput;
}>;


export type UpdateScreenMutation = { __typename?: 'Mutation', updateScreenEnvironment: { __typename?: 'Screen', id: string } };

export type DeleteScreenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScreenMutation = { __typename?: 'Mutation', deleteScreen?: string | null };

export type SubscriptionProductsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type SubscriptionProductsQuery = { __typename?: 'Query', app: { __typename?: 'App', config: { __typename?: 'FlowConfig', name: string, subscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', id: string, name: string, isInUse: boolean }> } } };

export type SubscriptionProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubscriptionProductQuery = { __typename?: 'Query', subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string, description?: string | null, sku: string, isInUse: boolean } };

export type CreateSubscriptionProductMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  input: CreateSubscriptionProductInput;
}>;


export type CreateSubscriptionProductMutation = { __typename?: 'Mutation', createSubscriptionProduct: { __typename?: 'SubscriptionProduct', id: string } };

export type UpdateSubscriptionProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionProductInput;
}>;


export type UpdateSubscriptionProductMutation = { __typename?: 'Mutation', updateSubscriptionProduct: { __typename?: 'SubscriptionProduct', id: string } };

export type DeleteSubscriptionProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubscriptionProductMutation = { __typename?: 'Mutation', deleteSubscriptionProduct?: string | null };

export type AppThemeQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type AppThemeQuery = { __typename?: 'Query', app: { __typename?: 'App', theme: { __typename?: 'Theme', id: string, colors: { __typename?: 'ThemeColors', text: string, textSecondary: string, button: string, buttonBorder: string, buttonFocused: string, buttonFocusedBorder: string, buttonText: string, buttonTextFocused: string, textInput: string, textInputBorder: string, textInputFocused: string, textInputFocusedBorder: string, badge: string, tag: string, progress: string, underline: string, navBarBackground: string, separator: string, background: string, overlay: string, loadingIndicator: string, cardFocusedBorder: string, cardPlaceholder: string }, logo: { __typename?: 'Image', key: string }, premiumIcon?: { __typename?: 'Image', key: string } | null, landscapeFallback?: { __typename?: 'Image', key: string } | null, portraitFallback?: { __typename?: 'Image', key: string } | null, squareFallback?: { __typename?: 'Image', key: string } | null } } };

export type AppThemeBackgroundColorQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  environment: Environment;
}>;


export type AppThemeBackgroundColorQuery = { __typename?: 'Query', app: { __typename?: 'App', theme: { __typename?: 'Theme', colors: { __typename?: 'ThemeColors', background: string } } } };

export type UpdateThemeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  environment: Environment;
  input: UpdateThemeInput;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateThemeEnvironment: { __typename?: 'Theme', id: string } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', username: string, email: string, firstName: string, lastName: string, role: Role, hasCompletedRegistration: boolean, isTwoFactorEnabled: boolean, createdAt: any, apps: Array<{ __typename?: 'App', name: string, account: { __typename?: 'Account', name: string } }> }> };

export type UserQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', email: string, firstName: string, lastName: string, hasCompletedRegistration: boolean, isTwoFactorEnabled: boolean, role: Role, apps: Array<{ __typename?: 'App', id: string, name: string, account: { __typename?: 'Account', name: string } }> } };

export type LoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserQuery = { __typename?: 'Query', loggedInUser: { __typename?: 'LoggedInUser', username: string, role: Role, firstName: string, lastName: string, email: string, isTwoFactorEnabled: boolean, phoneNumber?: string | null, apps: Array<{ __typename?: 'App', id: string, name: string, account: { __typename?: 'Account', name: string } }> } };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  appIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', username: string } };

export type UpdateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  appIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', username: string } };

export type DeleteUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: string };

export type UpdateMfaPreferenceMutationVariables = Exact<{
  useMFA: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdateMfaPreferenceMutation = { __typename?: 'Mutation', updateMFAPreference: string };

export const AuthenticationDataFragmentDoc = gql`
    fragment authenticationData on LoginResult {
  authenticationResult {
    accessToken
    expiresIn
    refreshToken
  }
  challengeName
  challengeParameters
  session
}
    `;
export const AccountsDocument = gql`
    query Accounts {
  accounts {
    id
    createdAt
    name
    url
    primaryContactName
    primaryContactEmail
    primaryContactPhone
    ensembleAccountManagerName
    deletionRequestingUser {
      username
      firstName
      lastName
      email
    }
  }
}
    `;
export const AccountDocument = gql`
    query Account($id: ID!) {
  account(id: $id) {
    name
    url
    primaryContactName
    primaryContactEmail
    primaryContactPhone
    ensembleAccountManagerName
  }
}
    `;
export const AccountNameDocument = gql`
    query AccountName($id: ID!) {
  account(id: $id) {
    name
  }
}
    `;
export const CreateAccountDocument = gql`
    mutation CreateAccount($name: String!, $url: String!, $primaryContactName: String!, $primaryContactEmail: String!, $primaryContactPhone: String!, $ensembleAccountManagerName: String!) {
  createAccount(
    input: {name: $name, url: $url, primaryContactName: $primaryContactName, primaryContactEmail: $primaryContactEmail, primaryContactPhone: $primaryContactPhone, ensembleAccountManagerName: $ensembleAccountManagerName}
  ) {
    id
  }
}
    `;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($id: ID!, $url: String!, $primaryContactName: String!, $primaryContactEmail: String!, $primaryContactPhone: String!, $ensembleAccountManagerName: String!) {
  updateAccount(
    id: $id
    input: {url: $url, primaryContactName: $primaryContactName, primaryContactEmail: $primaryContactEmail, primaryContactPhone: $primaryContactPhone, ensembleAccountManagerName: $ensembleAccountManagerName}
  ) {
    id
  }
}
    `;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($id: ID!) {
  deleteAccount(id: $id)
}
    `;
export const RemoveDeleteAccountRequestDocument = gql`
    mutation RemoveDeleteAccountRequest($id: ID!) {
  cancelAccountDeletionRequest(id: $id) {
    id
  }
}
    `;
export const AllAppsDocument = gql`
    query AllApps {
  apps {
    id
    name
    createdAt
    account {
      name
    }
  }
}
    `;
export const AccountAppsDocument = gql`
    query AccountApps($id: ID!) {
  apps(accountId: $id) {
    id
    name
    createdAt
    website
  }
}
    `;
export const AppDocument = gql`
    query App($id: ID!, $environment: Environment!) {
  app(id: $id) {
    name
    website
    lastPublished
    account {
      id
      name
    }
    platforms {
      id
      name
    }
    theme(environment: $environment) {
      logo {
        url
      }
    }
    status(environment: $environment) {
      state
    }
  }
}
    `;
export const AppDetailDocument = gql`
    query AppDetail($id: ID!, $environment: Environment!) {
  app(id: $id) {
    name
    website
    lastPublished
    account {
      id
      name
      ensembleAccountManagerName
    }
    platforms {
      id
      name
    }
    theme(environment: $environment) {
      logo {
        url
      }
    }
    deletionRequestingUser {
      username
      firstName
      lastName
      email
    }
    status(environment: $environment) {
      state
    }
  }
}
    `;
export const GenerationStatusDocument = gql`
    query GenerationStatus($id: ID!, $environment: Environment!) {
  configStatus(id: $id, environment: $environment) {
    state
    logs {
      message
    }
  }
}
    `;
export const AppsStatusesDocument = gql`
    query AppsStatuses($environment: Environment!) {
  getAllAppsStatuses(environment: $environment) {
    id
    account
    app
    appId
    environment
    status
    createdAt
    lastSuccessfulDate
  }
}
    `;
export const StatusDetailDocument = gql`
    query StatusDetail($id: ID!) {
  getStatusByStatusId(id: $id) {
    id
    account
    app
    appId
    environment
    status
    createdAt
    lastSuccessfulDate
    logs {
      message
    }
  }
}
    `;
export const CreateAppDocument = gql`
    mutation CreateApp($accountId: ID!, $input: CreateAppInput!) {
  createApp(accountId: $accountId, input: $input) {
    id
  }
}
    `;
export const UpdateAppDocument = gql`
    mutation UpdateApp($id: ID!, $input: UpdateAppInput!) {
  updateApp(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteAppDocument = gql`
    mutation DeleteApp($id: ID!) {
  deleteApp(id: $id)
}
    `;
export const PublishAppDocument = gql`
    mutation PublishApp($id: ID!) {
  publishAppStagingToProduction(id: $id)
}
    `;
export const RevertAppDocument = gql`
    mutation RevertApp($id: ID!) {
  abandonAppStagedChanges(id: $id)
}
    `;
export const TriggerConfigWriteDocument = gql`
    mutation TriggerConfigWrite($id: ID!, $env: Environment!) {
  triggerConfigWrite(appId: $id, environment: $env)
}
    `;
export const RemoveDeleteAppRequestDocument = gql`
    mutation RemoveDeleteAppRequest($id: ID!) {
  cancelAppDeletionRequest(id: $id) {
    id
  }
}
    `;
export const ResendRegistrationDocument = gql`
    mutation ResendRegistration($email: String!) {
  resendInvite(email: $email)
}
    `;
export const ValidateSessionDocument = gql`
    mutation ValidateSession($session: String!) {
  validateSession(session: $session)
}
    `;
export const ResetPasswordRequestDocument = gql`
    mutation ResetPasswordRequest($email: String!) {
  resetPassword(email: $email) {
    deliveryMedium
    destination
  }
}
    `;
export const NewPasswordDocument = gql`
    mutation NewPassword($email: String!, $newPassword: String!, $session: String!) {
  respondToAuthChallenge(
    input: {challengeName: NEW_PASSWORD_REQUIRED, newPasswordRequiredResponse: {email: $email, newPassword: $newPassword}, session: $session}
  ) {
    ...authenticationData
  }
}
    ${AuthenticationDataFragmentDoc}`;
export const ConfirmNewPasswordDocument = gql`
    mutation ConfirmNewPassword($session: String!, $password: String!, $code: String!) {
  confirmResetPassword(session: $session, password: $password, code: $code)
}
    `;
export const VerificationDocument = gql`
    mutation Verification($email: String!, $code: String!, $session: String!) {
  respondToAuthChallenge(
    input: {challengeName: SMS_MFA, smsMFAInput: {email: $email, code: $code}, session: $session}
  ) {
    ...authenticationData
  }
}
    ${AuthenticationDataFragmentDoc}`;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    ...authenticationData
  }
}
    ${AuthenticationDataFragmentDoc}`;
export const RefreshTokenLoginDocument = gql`
    mutation RefreshTokenLogin($refreshToken: String!) {
  refreshTokenLogin(refreshToken: $refreshToken) {
    authenticationResult {
      accessToken
    }
  }
}
    `;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export const SubmitProductConsentDocument = gql`
    mutation SubmitProductConsent {
  submitProductConsent
}
    `;
export const FeedsDocument = gql`
    query Feeds($appId: ID!, $environment: Environment) {
  feedsByApp(appId: $appId, environment: $environment) {
    edges {
      node {
        id
        name
        createdAt
        type
        platforms(environment: $environment) {
          id
          name
        }
        screenFeeds(environment: $environment) {
          id
        }
      }
    }
  }
}
    `;
export const FeedDocument = gql`
    query Feed($feedId: ID!, $environment: Environment!) {
  feed(id: $feedId, environment: $environment) {
    id
    name
    description
    type
    url
    contentIntegration {
      key
    }
    contentDetailIntegration {
      key
    }
    platforms(environment: $environment) {
      id
      name
    }
    screenFeeds(environment: $environment) {
      screen {
        id
        name
      }
    }
    nested
  }
}
    `;
export const UsedFeedIntegrationByAppDocument = gql`
    query UsedFeedIntegrationByApp($appId: ID!, $feedId: ID!, $environment: Environment) {
  usedIntegrationByApp(appId: $appId, feedId: $feedId, environment: $environment) {
    usedContentIntegration
    usedContentDetailIntegration
  }
}
    `;
export const CreateFeedDocument = gql`
    mutation CreateFeed($appId: ID!, $input: CreateFeedInput!) {
  createFeed(appId: $appId, input: $input) {
    id
  }
}
    `;
export const UpdateFeedDocument = gql`
    mutation UpdateFeed($id: ID!, $environment: Environment!, $input: UpdateFeedEnvironmentInput!) {
  updateFeedEnvironment(id: $id, environment: $environment, input: $input) {
    id
  }
}
    `;
export const DeleteFeedDocument = gql`
    mutation DeleteFeed($id: ID!) {
  deleteFeed(id: $id)
}
    `;
export const FileDocument = gql`
    query File($key: String!) {
  file(key: $key) {
    key
    url
    filename
    size
  }
}
    `;
export const ImageLibraryDocument = gql`
    query ImageLibrary($type: ImageType!, $accountId: ID!) {
  images(type: $type, accountId: $accountId) {
    key
    url
    filename
    size
    mimeType
  }
}
    `;
export const IntegrationsDocument = gql`
    query Integrations($types: [IntegrationType!]) {
  integrations(types: $types) {
    id
    key
    type
  }
}
    `;
export const ConfigIntegrationsDocument = gql`
    query ConfigIntegrations($id: ID!) {
  flowConfig(id: $id) {
    integrations {
      integration {
        id
        key
        type
      }
      settingsJson
      createdAt
    }
  }
}
    `;
export const SubmitIntegrationsDocument = gql`
    mutation SubmitIntegrations($id: ID!, $input: UpdateFlowConfigInput!) {
  updateFlowConfig(id: $id, input: $input) {
    id
  }
}
    `;
export const AddIntegrationDocument = gql`
    mutation AddIntegration($id: ID!, $input: FlowConfigAddUpdateIntegrationInput!) {
  addConfigIntegration(id: $id, input: $input)
}
    `;
export const UpdateIntegrationDocument = gql`
    mutation UpdateIntegration($id: ID!, $input: FlowConfigAddUpdateIntegrationInput!) {
  updateConfigIntegration(id: $id, input: $input)
}
    `;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($id: ID!, $integrationId: ID!) {
  deleteConfigIntegration(id: $id, integrationId: $integrationId)
}
    `;
export const LocalizedTranslationsDocument = gql`
    query LocalizedTranslations($appId: ID!, $environment: Environment!, $namespace: LocalizationNamespace!, $localeCode: String!) {
  localizedTranslations(
    appId: $appId
    environment: $environment
    namespace: $namespace
    localeCode: $localeCode
  ) {
    localeCode
    key
    value
    isFallbackToDefault
  }
}
    `;
export const SetLocalizedTranslationsDocument = gql`
    mutation SetLocalizedTranslations($appId: ID!, $environment: Environment!, $namespace: LocalizationNamespace!, $localeCode: String!, $input: SetLocalizedTranslationsInput!) {
  setLocalizedTranslations(
    appId: $appId
    environment: $environment
    namespace: $namespace
    localeCode: $localeCode
    input: $input
  )
}
    `;
export const UpdateLocalizedTranslationsDocument = gql`
    mutation UpdateLocalizedTranslations($appId: ID!, $environment: Environment!, $namespace: LocalizationNamespace!, $localeCode: String!, $input: UpdateLocalizedTranslationsInput!) {
  updateLocalizedTranslations(
    appId: $appId
    environment: $environment
    namespace: $namespace
    localeCode: $localeCode
    input: $input
  )
}
    `;
export const NavBarItemDocument = gql`
    query NavBarItem($id: ID!) {
  navBarItem(id: $id) {
    id
    label
    screenType
    requireAuthenticated
    requireSubscribed
    icon {
      key
    }
    context
  }
}
    `;
export const NavBarScreenTypesDocument = gql`
    query NavBarScreenTypes($configId: ID!) {
  navBarItems(configId: $configId) {
    screenType
  }
}
    `;
export const CreateNavBarItemDocument = gql`
    mutation CreateNavBarItem($configId: ID!, $input: CreateNavBarItemInput!) {
  addNavBarItem(configId: $configId, input: $input) {
    id
  }
}
    `;
export const UpdateNavBarItemDocument = gql`
    mutation UpdateNavBarItem($id: ID!, $input: UpdateNavBarItemInput!) {
  updateNavBarItem(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateNavBarOrderDocument = gql`
    mutation UpdateNavBarOrder($configId: ID!, $input: SetNavBarOrderInput!) {
  setNavBarOrder(configId: $configId, input: $input)
}
    `;
export const DeleteNavBarItemDocument = gql`
    mutation DeleteNavBarItem($id: ID!) {
  deleteNavBarItem(id: $id)
}
    `;
export const AllPlatformsDocument = gql`
    query AllPlatforms {
  platforms {
    id
    name
  }
}
    `;
export const AppConfigsDocument = gql`
    query AppConfigs($appId: ID!, $environment: Environment!) {
  app(id: $appId) {
    configs(environment: $environment) {
      flowVersion
      deletionRequestingUser {
        username
        firstName
        lastName
      }
      platform {
        id
      }
      lastModifiedByUser {
        firstName
        lastName
      }
    }
    platforms {
      id
      name
      createdAt
    }
  }
}
    `;
export const ConfigDocument = gql`
    query Config($appId: ID!, $platformId: ID!, $environment: Environment!) {
  app(id: $appId) {
    config(platformId: $platformId, environment: $environment) {
      id
      name
      minSDKVersion
      certificationStatus
      flowVersion
      features
      subscriptionProducts {
        id
        name
        createdAt
        description
        sku
        isInUse
      }
      navBarItems {
        id
        screenType
        label
        requireAuthenticated
        requireSubscribed
        screen {
          id
          name
        }
        icon {
          filename
          url
        }
      }
      integrations {
        integration {
          id
          key
          type
        }
        createdAt
      }
    }
  }
}
    `;
export const ConfigIdDocument = gql`
    query ConfigId($appId: ID!, $platformId: ID!, $environment: Environment!) {
  app(id: $appId) {
    config(platformId: $platformId, environment: $environment) {
      id
    }
  }
}
    `;
export const CreateAppPlatformDocument = gql`
    mutation CreateAppPlatform($appId: ID!, $platformId: ID!) {
  addPlatformToApp(appId: $appId, platformId: $platformId) {
    id
  }
}
    `;
export const UpdateConfigDocument = gql`
    mutation UpdateConfig($id: ID!, $input: UpdateFlowConfigInput!) {
  updateFlowConfig(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteAppPlatformDocument = gql`
    mutation DeleteAppPlatform($appId: ID!, $platformId: ID!) {
  deleteAppPlatform(appId: $appId, platformId: $platformId)
}
    `;
export const ScreenFeedDocument = gql`
    query ScreenFeed($id: ID!, $environment: Environment!) {
  screenFeed(id: $id) {
    id
    title
    order
    layout
    itemLayout
    action
    rowItemPageSize
    rowPageSize
    refreshPolicy {
      refreshOnScreenResume
      refreshIntervalSeconds
    }
    feed(environment: $environment) {
      id
      name
    }
  }
}
    `;
export const ScreenFeedsDocument = gql`
    query ScreenFeeds($screenId: ID!, $environment: Environment!) {
  screenFeeds(screenId: $screenId, environment: $environment) {
    id
    title
    order
    layout
    itemLayout
    action
    rowItemPageSize
    rowPageSize
    refreshPolicy {
      refreshOnScreenResume
      refreshIntervalSeconds
    }
  }
}
    `;
export const ScreenFeedDetailDocument = gql`
    query ScreenFeedDetail($screenId: ID!, $feedId: ID!, $environment: Environment!) {
  screenFeedByScreenAndFeedIds(
    screenId: $screenId
    feedId: $feedId
    environment: $environment
  ) {
    id
    title
    order
    layout
    itemLayout
    action
    rowItemPageSize
    rowPageSize
    refreshPolicy {
      refreshOnScreenResume
      refreshIntervalSeconds
    }
    feed(environment: $environment) {
      id
      name
    }
  }
}
    `;
export const CreateScreenFeedDocument = gql`
    mutation CreateScreenFeed($input: CreateScreenFeedInput!) {
  createScreenFeed(input: $input) {
    id
    title
    order
    layout
    itemLayout
    action
    rowItemPageSize
    rowPageSize
  }
}
    `;
export const UpdateScreenFeedDocument = gql`
    mutation UpdateScreenFeed($id: ID!, $input: UpdateScreenFeedInput!) {
  updateScreenFeed(id: $id, input: $input) {
    id
    title
    order
    layout
    itemLayout
    action
    rowItemPageSize
    rowPageSize
  }
}
    `;
export const DeleteScreenFeedDocument = gql`
    mutation DeleteScreenFeed($id: ID!) {
  deleteScreenFeed(id: $id)
}
    `;
export const ScreensDocument = gql`
    query Screens($appId: ID!, $environment: Environment!) {
  screens(appId: $appId, environment: $environment) {
    id
    name
    createdAt
    type
    platforms(environment: $environment) {
      id
      name
    }
  }
}
    `;
export const ScreenDocument = gql`
    query Screen($id: ID!, $environment: Environment!, $locale: String!) {
  screen(id: $id, environment: $environment) {
    id
    type
    name
    allowAppRefresh
    platforms(environment: $environment) {
      id
      name
    }
    screenFeeds {
      id
      order
      feed(environment: $environment) {
        id
        name
      }
      layout
      itemLayout
      action
      refreshPolicy {
        refreshOnScreenResume
        refreshIntervalSeconds
      }
      rowItemPageSize
      rowPageSize
    }
    localization(locale: $locale, environment: $environment) {
      key
      value
      isFallbackToDefault
    }
    splashScreen {
      backgroundImage {
        key
        url
      }
    }
    welcomeScreen {
      backgroundImage {
        key
        url
      }
      alwaysShowOnLaunch
    }
    loginScreen {
      backgroundImage {
        key
        url
      }
    }
    loginCodeScreen {
      backgroundImage {
        key
        url
      }
      pollingIntervalSeconds
      qrCode
    }
    registerScreen {
      backgroundImage {
        key
        url
      }
      passwordMinCharacters
      passwordUppercase
      passwordLowercase
      passwordNumber
      passwordNonAlphanumeric
    }
    forgotPasswordScreen {
      backgroundImage {
        key
        url
      }
    }
    forgotPasswordConfirmationScreen {
      backgroundImage {
        key
        url
      }
    }
    forgotPasswordExternalScreen {
      backgroundImage {
        key
        url
      }
    }
    homeScreen {
      backgroundImageLayout
      backgroundImage {
        key
        url
      }
    }
    browseScreen {
      backgroundImage {
        key
        url
      }
    }
    browseBScreen {
      backgroundImage {
        key
        url
      }
    }
    browseCScreen {
      backgroundImage {
        key
        url
      }
    }
    browseDScreen {
      backgroundImage {
        key
        url
      }
    }
    favoritesScreen {
      backgroundImage {
        key
        url
      }
    }
    continueWatchingScreen {
      backgroundImage {
        key
        url
      }
    }
    seriesDetailScreen {
      backgroundImageLayout
      primaryBackgroundImage {
        key
        url
      }
      secondaryBackgroundImage {
        key
        url
      }
    }
    movieDetailScreen {
      backgroundImageLayout
      primaryBackgroundImage {
        key
        url
      }
      secondaryBackgroundImage {
        key
        url
      }
    }
    searchScreen {
      backgroundImage {
        key
        url
      }
    }
    audioPlaybackScreen {
      backgroundImage {
        key
        url
      }
      progressHeartbeat
      upNextCountdown
      imageLayout
      upNextCue
    }
    videoPlaybackScreen {
      progressHeartbeat
      upNextCountdown
      upNextCue
      prerollAdFrequency
      imageLayout
    }
    upsellScreen {
      backgroundImage {
        key
        url
      }
    }
    paywallScreen {
      backgroundImage {
        key
        url
      }
    }
    manageSubscriptionScreen {
      backgroundImage {
        key
        url
      }
    }
    accountScreen {
      backgroundImage {
        key
        url
      }
    }
    termsServiceScreen {
      backgroundImage {
        key
        url
      }
    }
    termsPurchaseScreen {
      backgroundImage {
        key
        url
      }
    }
    faqScreen {
      backgroundImage {
        key
        url
      }
    }
    privacyPolicyScreen {
      backgroundImage {
        key
        url
      }
    }
    ccpaPrivacyScreen {
      backgroundImage {
        key
        url
      }
    }
    thirdPartySoftwareScreen {
      backgroundImage {
        key
        url
      }
    }
    supportScreen {
      backgroundImage {
        key
        url
      }
    }
    recommendationsChannelScreen {
      icon {
        key
        url
      }
    }
    forceUpdateScreen {
      backgroundImage {
        key
        url
      }
    }
    appExitScreen {
      backgroundImage {
        key
        url
      }
    }
    logoutConfirmationScreen {
      backgroundImage {
        key
        url
      }
    }
    deleteAccountScreen {
      backgroundImage {
        key
        url
      }
    }
    deleteAccountConfirmationScreen {
      backgroundImage {
        key
        url
      }
    }
    areYouStillWatchingScreen {
      countdown
      inactivityInterval
    }
    errorScreen {
      backgroundImage {
        key
        url
      }
    }
    privacyConsentScreen {
      backgroundImage {
        key
        url
      }
    }
    appSettingsScreen {
      backgroundImage {
        key
        url
      }
    }
    parentalPinScreen {
      backgroundImage {
        key
        url
      }
    }
    parentalPinSetScreen {
      backgroundImage {
        key
        url
      }
    }
    parentalPinForgotScreen {
      backgroundImage {
        key
        url
      }
    }
    homeMiniPlayerScreen {
      backgroundImage {
        key
        url
      }
      autoFullScreenTransition
    }
    parentalPinForgotSetScreen {
      backgroundImage {
        key
        url
      }
    }
    welcomePrivacyConsentScreen {
      backgroundImage {
        key
        url
      }
    }
    playlistDetailScreen {
      backgroundImageLayout
      primaryBackgroundImage {
        key
        url
      }
      secondaryBackgroundImage {
        key
        url
      }
    }
  }
}
    `;
export const CreateScreenDocument = gql`
    mutation CreateScreen($appId: ID!, $input: CreateScreenInput!) {
  createScreen(appId: $appId, input: $input) {
    id
  }
}
    `;
export const UpdateScreenDocument = gql`
    mutation UpdateScreen($id: ID!, $environment: Environment!, $input: UpdateScreenInput!) {
  updateScreenEnvironment(id: $id, environment: $environment, input: $input) {
    id
  }
}
    `;
export const DeleteScreenDocument = gql`
    mutation DeleteScreen($id: ID!) {
  deleteScreen(id: $id)
}
    `;
export const SubscriptionProductsDocument = gql`
    query SubscriptionProducts($appId: ID!, $platformId: ID!, $environment: Environment!) {
  app(id: $appId) {
    config(platformId: $platformId, environment: $environment) {
      name
      subscriptionProducts {
        id
        name
        isInUse
      }
    }
  }
}
    `;
export const SubscriptionProductDocument = gql`
    query SubscriptionProduct($id: ID!) {
  subscriptionProduct(id: $id) {
    id
    name
    description
    sku
    isInUse
  }
}
    `;
export const CreateSubscriptionProductDocument = gql`
    mutation CreateSubscriptionProduct($configId: ID!, $input: CreateSubscriptionProductInput!) {
  createSubscriptionProduct(configId: $configId, input: $input) {
    id
  }
}
    `;
export const UpdateSubscriptionProductDocument = gql`
    mutation UpdateSubscriptionProduct($id: ID!, $input: UpdateSubscriptionProductInput!) {
  updateSubscriptionProduct(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteSubscriptionProductDocument = gql`
    mutation DeleteSubscriptionProduct($id: ID!) {
  deleteSubscriptionProduct(id: $id)
}
    `;
export const AppThemeDocument = gql`
    query AppTheme($appId: ID!, $environment: Environment!) {
  app(id: $appId) {
    theme(environment: $environment) {
      id
      colors {
        text
        textSecondary
        button
        buttonBorder
        buttonFocused
        buttonFocusedBorder
        buttonText
        buttonTextFocused
        textInput
        textInputBorder
        textInputFocused
        textInputFocusedBorder
        badge
        tag
        progress
        underline
        navBarBackground
        separator
        background
        overlay
        loadingIndicator
        cardFocusedBorder
        cardPlaceholder
      }
      logo {
        key
      }
      premiumIcon {
        key
      }
      landscapeFallback {
        key
      }
      portraitFallback {
        key
      }
      squareFallback {
        key
      }
    }
  }
}
    `;
export const AppThemeBackgroundColorDocument = gql`
    query AppThemeBackgroundColor($appId: ID!, $environment: Environment!) {
  app(id: $appId) {
    theme(environment: $environment) {
      colors {
        background
      }
    }
  }
}
    `;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($id: ID!, $environment: Environment!, $input: UpdateThemeInput!) {
  updateThemeEnvironment(id: $id, environment: $environment, input: $input) {
    id
  }
}
    `;
export const UsersDocument = gql`
    query Users {
  users {
    username
    email
    firstName
    lastName
    role
    hasCompletedRegistration
    isTwoFactorEnabled
    apps {
      name
      account {
        name
      }
    }
    createdAt
  }
}
    `;
export const UserDocument = gql`
    query User($username: String!) {
  user(username: $username) {
    email
    firstName
    lastName
    hasCompletedRegistration
    isTwoFactorEnabled
    role
    apps {
      id
      name
      account {
        name
      }
    }
  }
}
    `;
export const LoggedInUserDocument = gql`
    query LoggedInUser {
  loggedInUser {
    username
    role
    firstName
    lastName
    apps {
      id
      name
      account {
        name
      }
    }
    email
    isTwoFactorEnabled
    phoneNumber
  }
}
    `;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $firstName: String!, $lastName: String!, $appIds: [String!]!) {
  createUser(
    input: {email: $email, firstName: $firstName, lastName: $lastName, appIds: $appIds}
  ) {
    username
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($email: String!, $firstName: String, $lastName: String, $role: Role, $appIds: [String!], $phoneNumber: String) {
  updateUser(
    email: $email
    input: {firstName: $firstName, lastName: $lastName, role: $role, appIds: $appIds, phoneNumber: $phoneNumber}
  ) {
    username
  }
}
    `;
export const DeleteUserDocument = gql`
    mutation DeleteUser($email: String!) {
  deleteUser(email: $email)
}
    `;
export const UpdateMfaPreferenceDocument = gql`
    mutation UpdateMFAPreference($useMFA: Boolean!, $phoneNumber: String!) {
  updateMFAPreference(useMFA: $useMFA, phoneNumber: $phoneNumber)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Accounts(variables?: AccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountsQuery>({ document: AccountsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Accounts', 'query', variables);
    },
    Account(variables: AccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountQuery>({ document: AccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Account', 'query', variables);
    },
    AccountName(variables: AccountNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountNameQuery>({ document: AccountNameDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AccountName', 'query', variables);
    },
    CreateAccount(variables: CreateAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccountMutation>({ document: CreateAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAccount', 'mutation', variables);
    },
    UpdateAccount(variables: UpdateAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccountMutation>({ document: UpdateAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateAccount', 'mutation', variables);
    },
    DeleteAccount(variables: DeleteAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAccountMutation>({ document: DeleteAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteAccount', 'mutation', variables);
    },
    RemoveDeleteAccountRequest(variables: RemoveDeleteAccountRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveDeleteAccountRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDeleteAccountRequestMutation>({ document: RemoveDeleteAccountRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveDeleteAccountRequest', 'mutation', variables);
    },
    AllApps(variables?: AllAppsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AllAppsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllAppsQuery>({ document: AllAppsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AllApps', 'query', variables);
    },
    AccountApps(variables: AccountAppsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountAppsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountAppsQuery>({ document: AccountAppsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AccountApps', 'query', variables);
    },
    App(variables: AppQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppQuery>({ document: AppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'App', 'query', variables);
    },
    AppDetail(variables: AppDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppDetailQuery>({ document: AppDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AppDetail', 'query', variables);
    },
    GenerationStatus(variables: GenerationStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerationStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerationStatusQuery>({ document: GenerationStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerationStatus', 'query', variables);
    },
    AppsStatuses(variables: AppsStatusesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppsStatusesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppsStatusesQuery>({ document: AppsStatusesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AppsStatuses', 'query', variables);
    },
    StatusDetail(variables: StatusDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<StatusDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatusDetailQuery>({ document: StatusDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'StatusDetail', 'query', variables);
    },
    CreateApp(variables: CreateAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAppMutation>({ document: CreateAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateApp', 'mutation', variables);
    },
    UpdateApp(variables: UpdateAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAppMutation>({ document: UpdateAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateApp', 'mutation', variables);
    },
    DeleteApp(variables: DeleteAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAppMutation>({ document: DeleteAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteApp', 'mutation', variables);
    },
    PublishApp(variables: PublishAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublishAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishAppMutation>({ document: PublishAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PublishApp', 'mutation', variables);
    },
    RevertApp(variables: RevertAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RevertAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevertAppMutation>({ document: RevertAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RevertApp', 'mutation', variables);
    },
    TriggerConfigWrite(variables: TriggerConfigWriteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TriggerConfigWriteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TriggerConfigWriteMutation>({ document: TriggerConfigWriteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TriggerConfigWrite', 'mutation', variables);
    },
    RemoveDeleteAppRequest(variables: RemoveDeleteAppRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveDeleteAppRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDeleteAppRequestMutation>({ document: RemoveDeleteAppRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveDeleteAppRequest', 'mutation', variables);
    },
    ResendRegistration(variables: ResendRegistrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResendRegistrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendRegistrationMutation>({ document: ResendRegistrationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResendRegistration', 'mutation', variables);
    },
    ValidateSession(variables: ValidateSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ValidateSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidateSessionMutation>({ document: ValidateSessionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ValidateSession', 'mutation', variables);
    },
    ResetPasswordRequest(variables: ResetPasswordRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResetPasswordRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetPasswordRequestMutation>({ document: ResetPasswordRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResetPasswordRequest', 'mutation', variables);
    },
    NewPassword(variables: NewPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NewPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewPasswordMutation>({ document: NewPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NewPassword', 'mutation', variables);
    },
    ConfirmNewPassword(variables: ConfirmNewPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmNewPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmNewPasswordMutation>({ document: ConfirmNewPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmNewPassword', 'mutation', variables);
    },
    Verification(variables: VerificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VerificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationMutation>({ document: VerificationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Verification', 'mutation', variables);
    },
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Login', 'mutation', variables);
    },
    RefreshTokenLogin(variables: RefreshTokenLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RefreshTokenLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshTokenLoginMutation>({ document: RefreshTokenLoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RefreshTokenLogin', 'mutation', variables);
    },
    Logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>({ document: LogoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Logout', 'mutation', variables);
    },
    SubmitProductConsent(variables?: SubmitProductConsentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubmitProductConsentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubmitProductConsentMutation>({ document: SubmitProductConsentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubmitProductConsent', 'mutation', variables);
    },
    Feeds(variables: FeedsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FeedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeedsQuery>({ document: FeedsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Feeds', 'query', variables);
    },
    Feed(variables: FeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeedQuery>({ document: FeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Feed', 'query', variables);
    },
    UsedFeedIntegrationByApp(variables: UsedFeedIntegrationByAppQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UsedFeedIntegrationByAppQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsedFeedIntegrationByAppQuery>({ document: UsedFeedIntegrationByAppDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UsedFeedIntegrationByApp', 'query', variables);
    },
    CreateFeed(variables: CreateFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFeedMutation>({ document: CreateFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateFeed', 'mutation', variables);
    },
    UpdateFeed(variables: UpdateFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFeedMutation>({ document: UpdateFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateFeed', 'mutation', variables);
    },
    DeleteFeed(variables: DeleteFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFeedMutation>({ document: DeleteFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteFeed', 'mutation', variables);
    },
    File(variables: FileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FileQuery>({ document: FileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'File', 'query', variables);
    },
    ImageLibrary(variables: ImageLibraryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ImageLibraryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImageLibraryQuery>({ document: ImageLibraryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ImageLibrary', 'query', variables);
    },
    Integrations(variables?: IntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IntegrationsQuery>({ document: IntegrationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Integrations', 'query', variables);
    },
    ConfigIntegrations(variables: ConfigIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfigIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfigIntegrationsQuery>({ document: ConfigIntegrationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfigIntegrations', 'query', variables);
    },
    SubmitIntegrations(variables: SubmitIntegrationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubmitIntegrationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubmitIntegrationsMutation>({ document: SubmitIntegrationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubmitIntegrations', 'mutation', variables);
    },
    AddIntegration(variables: AddIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddIntegrationMutation>({ document: AddIntegrationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddIntegration', 'mutation', variables);
    },
    UpdateIntegration(variables: UpdateIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateIntegrationMutation>({ document: UpdateIntegrationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateIntegration', 'mutation', variables);
    },
    DeleteIntegration(variables: DeleteIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteIntegrationMutation>({ document: DeleteIntegrationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteIntegration', 'mutation', variables);
    },
    LocalizedTranslations(variables: LocalizedTranslationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LocalizedTranslationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LocalizedTranslationsQuery>({ document: LocalizedTranslationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LocalizedTranslations', 'query', variables);
    },
    SetLocalizedTranslations(variables: SetLocalizedTranslationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetLocalizedTranslationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLocalizedTranslationsMutation>({ document: SetLocalizedTranslationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetLocalizedTranslations', 'mutation', variables);
    },
    UpdateLocalizedTranslations(variables: UpdateLocalizedTranslationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateLocalizedTranslationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLocalizedTranslationsMutation>({ document: UpdateLocalizedTranslationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateLocalizedTranslations', 'mutation', variables);
    },
    NavBarItem(variables: NavBarItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NavBarItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavBarItemQuery>({ document: NavBarItemDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NavBarItem', 'query', variables);
    },
    NavBarScreenTypes(variables: NavBarScreenTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NavBarScreenTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavBarScreenTypesQuery>({ document: NavBarScreenTypesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NavBarScreenTypes', 'query', variables);
    },
    CreateNavBarItem(variables: CreateNavBarItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateNavBarItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateNavBarItemMutation>({ document: CreateNavBarItemDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateNavBarItem', 'mutation', variables);
    },
    UpdateNavBarItem(variables: UpdateNavBarItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateNavBarItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateNavBarItemMutation>({ document: UpdateNavBarItemDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateNavBarItem', 'mutation', variables);
    },
    UpdateNavBarOrder(variables: UpdateNavBarOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateNavBarOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateNavBarOrderMutation>({ document: UpdateNavBarOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateNavBarOrder', 'mutation', variables);
    },
    DeleteNavBarItem(variables: DeleteNavBarItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteNavBarItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteNavBarItemMutation>({ document: DeleteNavBarItemDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteNavBarItem', 'mutation', variables);
    },
    AllPlatforms(variables?: AllPlatformsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AllPlatformsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPlatformsQuery>({ document: AllPlatformsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AllPlatforms', 'query', variables);
    },
    AppConfigs(variables: AppConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppConfigsQuery>({ document: AppConfigsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AppConfigs', 'query', variables);
    },
    Config(variables: ConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfigQuery>({ document: ConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Config', 'query', variables);
    },
    ConfigId(variables: ConfigIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfigIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfigIdQuery>({ document: ConfigIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfigId', 'query', variables);
    },
    CreateAppPlatform(variables: CreateAppPlatformMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateAppPlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAppPlatformMutation>({ document: CreateAppPlatformDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAppPlatform', 'mutation', variables);
    },
    UpdateConfig(variables: UpdateConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateConfigMutation>({ document: UpdateConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateConfig', 'mutation', variables);
    },
    DeleteAppPlatform(variables: DeleteAppPlatformMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteAppPlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAppPlatformMutation>({ document: DeleteAppPlatformDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteAppPlatform', 'mutation', variables);
    },
    ScreenFeed(variables: ScreenFeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ScreenFeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScreenFeedQuery>({ document: ScreenFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ScreenFeed', 'query', variables);
    },
    ScreenFeeds(variables: ScreenFeedsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ScreenFeedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScreenFeedsQuery>({ document: ScreenFeedsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ScreenFeeds', 'query', variables);
    },
    ScreenFeedDetail(variables: ScreenFeedDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ScreenFeedDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScreenFeedDetailQuery>({ document: ScreenFeedDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ScreenFeedDetail', 'query', variables);
    },
    CreateScreenFeed(variables: CreateScreenFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateScreenFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateScreenFeedMutation>({ document: CreateScreenFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateScreenFeed', 'mutation', variables);
    },
    UpdateScreenFeed(variables: UpdateScreenFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateScreenFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateScreenFeedMutation>({ document: UpdateScreenFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateScreenFeed', 'mutation', variables);
    },
    DeleteScreenFeed(variables: DeleteScreenFeedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteScreenFeedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteScreenFeedMutation>({ document: DeleteScreenFeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteScreenFeed', 'mutation', variables);
    },
    Screens(variables: ScreensQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ScreensQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScreensQuery>({ document: ScreensDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Screens', 'query', variables);
    },
    Screen(variables: ScreenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ScreenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScreenQuery>({ document: ScreenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Screen', 'query', variables);
    },
    CreateScreen(variables: CreateScreenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateScreenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateScreenMutation>({ document: CreateScreenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateScreen', 'mutation', variables);
    },
    UpdateScreen(variables: UpdateScreenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateScreenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateScreenMutation>({ document: UpdateScreenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateScreen', 'mutation', variables);
    },
    DeleteScreen(variables: DeleteScreenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteScreenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteScreenMutation>({ document: DeleteScreenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteScreen', 'mutation', variables);
    },
    SubscriptionProducts(variables: SubscriptionProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubscriptionProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionProductsQuery>({ document: SubscriptionProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubscriptionProducts', 'query', variables);
    },
    SubscriptionProduct(variables: SubscriptionProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubscriptionProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionProductQuery>({ document: SubscriptionProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubscriptionProduct', 'query', variables);
    },
    CreateSubscriptionProduct(variables: CreateSubscriptionProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSubscriptionProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubscriptionProductMutation>({ document: CreateSubscriptionProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSubscriptionProduct', 'mutation', variables);
    },
    UpdateSubscriptionProduct(variables: UpdateSubscriptionProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSubscriptionProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSubscriptionProductMutation>({ document: UpdateSubscriptionProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateSubscriptionProduct', 'mutation', variables);
    },
    DeleteSubscriptionProduct(variables: DeleteSubscriptionProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSubscriptionProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSubscriptionProductMutation>({ document: DeleteSubscriptionProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteSubscriptionProduct', 'mutation', variables);
    },
    AppTheme(variables: AppThemeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppThemeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppThemeQuery>({ document: AppThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AppTheme', 'query', variables);
    },
    AppThemeBackgroundColor(variables: AppThemeBackgroundColorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AppThemeBackgroundColorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppThemeBackgroundColorQuery>({ document: AppThemeBackgroundColorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AppThemeBackgroundColor', 'query', variables);
    },
    UpdateTheme(variables: UpdateThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateThemeMutation>({ document: UpdateThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateTheme', 'mutation', variables);
    },
    Users(variables?: UsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersQuery>({ document: UsersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Users', 'query', variables);
    },
    User(variables: UserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuery>({ document: UserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'User', 'query', variables);
    },
    LoggedInUser(variables?: LoggedInUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoggedInUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoggedInUserQuery>({ document: LoggedInUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LoggedInUser', 'query', variables);
    },
    CreateUser(variables: CreateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>({ document: CreateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateUser', 'mutation', variables);
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>({ document: UpdateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateUser', 'mutation', variables);
    },
    DeleteUser(variables: DeleteUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserMutation>({ document: DeleteUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteUser', 'mutation', variables);
    },
    UpdateMFAPreference(variables: UpdateMfaPreferenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateMfaPreferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMfaPreferenceMutation>({ document: UpdateMfaPreferenceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateMFAPreference', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;